(function () {
    'use strict';

    angular
        .module('digitHeiligenacht', [
            'angular-storage',
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngSanitize',
            'ngTouch',
            'restangular',
            'ui.router',
            'duScroll',
            'ksSwiper',
            'mediaPlayer',
            'uuid',
            'jlareau.bowser',
            'angulartics',
            'angulartics.google.tagmanager',
            'pascalprecht.translate'
        ]);

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('whenScrolled', whenScrolled);


    /** @ngInject */
    function whenScrolled () {
        var directive = {
            restrict: 'A',
            scope: true,
            controller: WhenScrolledController,
            controllerAs: 'ws',
            bindToController: {
                whenScrolled : "="
            }
        };

        return directive;

        /** @ngInject */
        function WhenScrolledController ($scope, $window, $timeout, reqAnimationFrame) {

            var vm = this;

            var scrolled = false;
            var threshold = 35;

            if(angular.isDefined(vm.whenScrolled.threshold)) {
                threshold = vm.whenScrolled.threshold;
            }

            var checkScrolling = function() {

                if($window.pageYOffset >= threshold && !scrolled) {

                    scrolled = true;
                    $scope.$eval(vm.whenScrolled.start);
                    $scope.$apply();

                }

                if($window.pageYOffset < threshold && scrolled) {

                    scrolled = false;
                    $scope.$eval(vm.whenScrolled.end);
                    $scope.$apply();

                }
            };

            $timeout(checkScrolling, 0); // fire once

            reqAnimationFrame(function() {

                checkScrolling(); // fire on scrolling via reqAnimateionFrame-Service

            });

        }
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('whenInViewport', whenInViewport);


    /** @ngInject */
    function whenInViewport ($timeout, $window, $document) {
        var directive = {
            restrict: 'A',
            scope: true,
            link: linkFunc,
            controller: WhenInViewportController,
            controllerAs: 'vm',
            bindToController: {
                whenInViewport: '&',
                wivAt: '@', // can be top or bottom
                wivBuffer: '=?'
            }
        };

        return directive;


        function linkFunc (scope, element, attrs, vm) {


            var setProperties = function () {


                vm.positionTop = element[0].getBoundingClientRect().top + $window.pageYOffset;

                vm.height = element[0].offsetHeight;

                vm.bodyOffset = parseInt($window.getComputedStyle($document[0].body).getPropertyValue('padding-top'), 10);

                vm.winHeight = $window.innerHeight;
            };


            $timeout(setProperties, 0);


            scope.$on('dom::changed', setProperties);
        }


        /** @ngInject */
        function WhenInViewportController ($scope, reqAnimationFrame, $timeout) {


            var vm = this;


            if (!vm.wivAt) {

                vm.wivAt = 'top';
            }


            if (!vm.wivBuffer) {

                vm.wivBuffer = 50;
            }


            var buffer = vm.wivBuffer;


            var hasFired = false;


            var startWatcher = function () {


                reqAnimationFrame(function () {


                    var scrollPos = $window.pageYOffset;


                    var isInViewport;


                    switch (vm.wivAt) {

                        case 'top' :

                            isInViewport = scrollPos >= (vm.positionTop - vm.bodyOffset - buffer) && scrollPos < (vm.positionTop + vm.height - vm.bodyOffset - buffer);
                            break;


                        case 'bottom' :

                            isInViewport = scrollPos >= (vm.positionTop - vm.winHeight + buffer) && (scrollPos + vm.height) < (vm.positionTop + vm.height + buffer);
                            break;
                    }


                    if (isInViewport && !hasFired) {


                        hasFired = true;


                        vm.whenInViewport();


                        $scope.$apply();
                    }


                    if (!isInViewport) {

                        hasFired = false;
                    }
                });
            };


            $timeout(startWatcher, 0);
        }
    }
})();

/* global OpenSeadragon: false */

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .directive('uiZoomimage', uiZoomimage);


    /** @ngInject */
    function uiZoomimage ($timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-zoomimage/ui-zoomimage.html',
            scope: true,
            controller: UiZoomimageController,
            controllerAs: 'zi',
            link : linkFunc,
            bindToController: {
                options : "=",
                progress : "=",
                debug : '='
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, ele, attrs, vm) {


            vm.viewer = new OpenSeadragon({
                element: ele[0].querySelector('.ui-zoomimage__inner div'),
                tileSources: [vm.options.tiles],
                springStiffness : 15,
                showNavigationControl: false,
                mouseNavEnabled : false
            });


            //    window.v = vm.viewer;

            vm.viewer.addHandler("open", function() {

                vm.setupViewport();

                // nicht schön, aber selten

                $timeout(function(){

                    vm.setZoom();
                },500);


                scope.$on('dom::changed', vm.setZoom);
            });
        }


        /** @ngInject */
        function UiZoomimageController ($scope) {


            var vm = this;


            var maxZoom = vm.options.maxZoom;


            vm.ratio = vm.options.height / vm.options.width;

            vm.viewportSet = false;


            var originCenter,
                targetCenter;


            vm.setupViewport = function() {

                var viewportCenterOrigin = {
                    x : vm.options.width / vm.options.width / 2,
                    y : vm.options.height / vm.options.width / 2
                };


                originCenter = new OpenSeadragon.Point(viewportCenterOrigin.x,viewportCenterOrigin.y);


                var viewportCenterOffset = {
                    x : (vm.options.width + vm.options.offset.x) / vm.options.width / 2,
                    y : (vm.options.height + vm.options.offset.y) / vm.options.width / 2
                };


                targetCenter = new OpenSeadragon.Point(viewportCenterOffset.x,viewportCenterOffset.y);



                vm.viewportSet = true;

            };



            vm.setZoom = function() {


                var f = 1;


                if (vm.progress) {


                    // start later, stop earlier
                    var progress = vm.progress * 1.6 - 0.2;


                    f = 1 - (progress > 0 ? progress : 0);
                }


                // default (no) zoom is 1
                var newZoom = 1 + (f * maxZoom);


                var newCenter = {
                    x : originCenter.x + ((targetCenter.x - originCenter.x) * f ),
                    y : originCenter.y + ((targetCenter.y - originCenter.y) * f )
                };

                newCenter = new OpenSeadragon.Point(newCenter.x, newCenter.y);


                if (newZoom >= 1) {

                    vm.viewer.viewport.zoomTo(newZoom);
                    vm.viewer.viewport.panTo(newCenter);
                }
                else {

                    vm.viewer.viewport.zoomTo(1);
                    vm.viewer.viewport.panTo(originCenter);
                }
            };



            $scope.$watch("zi.progress", function(newVal, oldVal){

                if (newVal !== oldVal) {

                    if (vm.viewportSet) {
                        vm.setZoom();
                    }
                }
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiSocialicon', uiSocialicon);


    /** @ngInject */
    function uiSocialicon () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-socialicon/ui-socialicon.html',
            scope: true,
            replace: true,
            controller: UiSocialiconController,
            controllerAs: 'icon',
            link : linkFunc,
            bindToController: {
                type : '@',
                href : '@',
                theme : '@',
                newWindow : '=?'
            }
        };

        return directive;


        function linkFunc(scope, ele, attr, vm) {

            vm.link = ele[0].querySelector("a");
        }

        /** @ngInject */
        function UiSocialiconController (_) {

            var vm = this;

            if (_.isUndefined(vm.newWindow)) {
                vm.newWindow = true;
            }

            if(!vm.type){
                vm.type = 'tbd';
            }

            if(!vm.theme) {
                vm.theme = 'dark';
            }

            // if this is no real link, unfocus after click
            vm.blurCond = function() {

                if(!vm.href) {
                    vm.link.blur();
                }
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiScrollmove', uiScrollmove);


    /** @ngInject */
    function uiScrollmove ($timeout, $window) {
        var directive = {
            restrict: 'A',
            scope: true,
            controller: UiScrollmoveController,
            controllerAs: 'vm',
            link : linkFunc,
            bindToController: {
                uiScrollmove : '@',
                buffer : '=?',
                endAtY : '=?',
                endAtX : '=?',
                forcePosX : '=?'
            }
        };

        return directive;


        function linkFunc(scope, element, attrs, vm) {

            var setProperties = function() {

                vm.positionTop = element[0].getBoundingClientRect().top + $window.pageYOffset;
                vm.height = element[0].offsetHeight;
                vm.winHeight = $window.innerHeight;
                vm.winWidth = $window.innerWidth;
            };

            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);
        }

        /** @ngInject */
        function UiScrollmoveController (reqAnimationFrame, $element, _, $rootScope, $scope) {

            var vm = this;


            if(_.isUndefined(vm.endAtY)) {

                vm.endAtY = 0; // this defines on which height to end the animation, multiplyer for winHeight
            }

            if(_.isUndefined(vm.endAtX)) {

                vm.endAtX = 0; // this is rem shifting, from the center to left or right
            }

            if(_.isUndefined(vm.buffer)) {

                vm.buffer = 0;
            }


            var setPositions = function() {

                var scrollPos = $window.pageYOffset;
                var isInViewport = scrollPos > vm.positionTop - vm.winHeight - 50 && scrollPos < vm.positionTop + vm.height;

                if (isInViewport) {
                    $element.removeClass('trans');
                    setStyles($element[0]);
                }
            };


            var xShift;


            var setStyles = function(ele) {


                var direction = 0;

                if ( vm.uiScrollmove === 'right' ) {
                    direction = 1;
                }

                if (vm.uiScrollmove === 'left') {
                    direction = -1;
                }


                var elePosTop = ele.getBoundingClientRect().top - (vm.winHeight * vm.endAtY),
                    elePosRelative = elePosTop / (vm.winHeight - vm.winHeight * vm.endAtY),
                    wayToGo = vm.winWidth / 2 + vm.buffer;


                xShift = easeInQuad(elePosRelative) * wayToGo * direction;

                // no more moving when top is reached

                if (elePosTop < 0) {

                    xShift = 0;
                }


                // adding the defined offset

                xShift = xShift / $rootScope.baseFontSize + vm.endAtX;


                // stay where you are when x is forced
                if (!vm.forcePosX) {

                    transformTo(ele, xShift);
                }
            };


            var transformTo = function(ele, xShift) {

                var transform = "translate(" + xShift + "rem, 0)";

                ele.style.transform = transform;
                ele.style['-ms-transform'] = transform;
            };


            var easeInQuad = function(t) {
                return t*t;
            };


            reqAnimationFrame(setPositions);


            $scope.$watch('vm.forcePosX', function(val){

                // when x is forced, immediately animate to this position

                if(!_.isUndefined(val) && val) {

                    $element.addClass('trans');
                    transformTo($element[0], (val));
                }
                else {

                    $element.addClass('trans');
                    transformTo($element[0], xShift);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiScrollfixNonclone', uiScrollfixNonclone);


    /** @ngInject */
    function uiScrollfixNonclone ($timeout, $window) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-scrollfix-nonclone/ui-scrollfix-nonclone.html',
            scope: true,
            controller: UiScrollfixNoncloneController,
            controllerAs: 'sf',
            link : linkFunc,
            bindToController: {
                fixDuration : '=',
                progress : '=?',
                fixEdge : '@',
                unboundProgress : '='
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, sf) {

            sf.inner = element[0].querySelector('.ui-scrollfix-nonclone__content');


            var setProperties = function() {

                sf.positionTop = element[0].childNodes[0].getBoundingClientRect().top + $window.pageYOffset;
                sf.height = element[0].childNodes[0].offsetHeight;
                sf.innerHeight = sf.inner.offsetHeight;
                sf.winHeight = $window.innerHeight;
            };


            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);
        }



        /** @ngInject */
        function UiScrollfixNoncloneController ($scope, reqAnimationFrame, $window) {

            var sf = this;

            sf.stylesOuter = {};
            sf.stylesInner = {};


            // fixDuration is noted in viewportHeight units (lik vh)
            var duration = sf.fixDuration / 100 * $window.innerHeight;

            var fixed = false;

            sf.progress = 0;



            var doInitialStyles = function() {

                sf.stylesOuter['padding-bottom'] = duration + 'px';
            };



            var doScrollfix = function() {

                var containerIsInViewport = $window.pageYOffset > sf.positionTop - sf.winHeight && $window.pageYOffset < sf.positionTop + sf.height;

                if (containerIsInViewport) {
                    handleScrollfix();
                }
                else {
                    unfix();
                }
            };



            var handleScrollfix = function () {

                var topEdge = (sf.winHeight - sf.innerHeight) / 2; // trying to center the whole element on the screen


                if (sf.fixEdge === 'top') {

                    topEdge = sf.winHeight * 1/4; // stopping the top edge at the first quarter of the screen,
                }


                if (sf.fixEdge === 'bottom') {

                    topEdge = sf.innerHeight * -1 + sf.winHeight * 3/4; // stopping the bottom edge at the last quarter of the screen,
                }


                if (topEdge < 0 && sf.fixEdge !== 'bottom' && sf.fixEdge !== 'top') {

                    topEdge = 0; // when trying to center, don't stop top edge outside of viewport
                }



                var isAtTopEdge = $window.pageYOffset >= sf.positionTop - topEdge,
                    isAtBottomEdge = $window.pageYOffset >= sf.positionTop - topEdge + duration;



                if (!sf.unboundProgress) {
                    if (isAtTopEdge && !isAtBottomEdge) {
                        sf.progress = ($window.pageYOffset - sf.positionTop + topEdge) / duration;
                    }
                }
                else {
                    sf.progress = ($window.pageYOffset - sf.positionTop + topEdge) / duration;
                }


                // scrolling top down or bottom up, entering hot area

                if (isAtTopEdge && !isAtBottomEdge && !fixed) {

                    fixed = true;


                    sf.stylesInner = {
                        position : 'fixed',
                        top: topEdge + 'px',
                        left: 0,
                        width: '100%'
                    };

                    sf.stylesOuter = {
                        'padding-top' : duration + sf.innerHeight + 'px'
                    };
                }


                // scrolling bottom up, exiting hot area

                if (!isAtTopEdge && !isAtBottomEdge && fixed) {

                    fixed = false;

                    sf.stylesInner = { position : 'relative', top: 'auto', left: 'auto', width: 'auto'};

                    sf.stylesOuter = {
                        'padding-bottom' : duration + 'px'
                    };

                    if (!sf.unboundProgress) {
                        sf.progress = 0;
                    }
                }


                // scrolling top down, exiting hot area

                if (isAtBottomEdge && fixed) {

                    fixed = false;

                    sf.stylesOuter = {
                        'padding-top' : duration + 'px'
                    };

                    sf.stylesInner = { position : 'relative', top: 'auto', left: 'auto', width: 'auto'};

                    if (!sf.unboundProgress) {
                        sf.progress = 1;
                    }
                }


                $scope.$apply();
            };


            var unfix = function () {

                if (fixed) {

                    fixed = false;

                    sf.stylesInner = {
                        position : 'relative',
                        top: 'auto',
                        left: 'auto',
                        width: 'auto'
                    };

                    $scope.$apply();
                }
            };


            // start

            doInitialStyles();

            reqAnimationFrame(doScrollfix);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiScrollfix', uiScrollfix);


    /** @ngInject */
    function uiScrollfix ($timeout, $window) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-scrollfix/ui-scrollfix.html',
            scope: true,
            controller: UiScrollfixController,
            controllerAs: 'sf',
            link : linkFunc,
            bindToController: {
                fixDuration : '=',
                progress : '=?',
                fixEdge : '@',
                unboundProgress : '='
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, sf) {

            sf.inner = element[0].querySelector('.ui-scrollfix__content');


            var setProperties = function() {

                sf.positionTop = element[0].childNodes[0].getBoundingClientRect().top + $window.pageYOffset;
                sf.height = element[0].childNodes[0].offsetHeight;
                sf.innerHeight = sf.inner.offsetHeight;
                sf.winHeight = $window.innerHeight;


                var topEdge = (sf.winHeight - sf.innerHeight) / 2; // trying to center the whole element on the screen


                if (sf.fixEdge === 'top') {

                    topEdge = sf.winHeight * 1/4; // stopping the top edge at the first quarter of the screen,
                }


                if (sf.fixEdge === 'bottom') {

                    topEdge = sf.innerHeight * -1 + sf.winHeight * 3/4; // stopping the bottom edge at the last quarter of the screen,
                }


                if (topEdge < 0 && sf.fixEdge !== 'bottom' && sf.fixEdge !== 'top') {

                    topEdge = 0; // when trying to center, don't stop top edge outside of viewport
                }


                sf.stylesClone.top = topEdge + 'px';

                sf.topEdge = topEdge;
            };


            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);
        }



        /** @ngInject */
        function UiScrollfixController ($scope, reqAnimationFrame, $window) {

            var sf = this;




            // fixDuration is noted in viewportHeight units (lik vh)
            var duration = sf.fixDuration / 100 * $window.innerHeight;

            var fixed = false;

            sf.progress = 0;


            sf.stylesOriginal = {};
            sf.stylesClone = {};
            sf.stylesOuter = {
                'padding-bottom' : duration + 'px'
            };


            var doScrollfix = function() {

                var containerIsInViewport = $window.pageYOffset > sf.positionTop - sf.winHeight && $window.pageYOffset < sf.positionTop + sf.height;

                if (containerIsInViewport) {
                    handleScrollfix();
                }
                else {
                    unfix();
                }
            };



            var handleScrollfix = function () {


                var isAtTopEdge = $window.pageYOffset >= sf.positionTop - sf.topEdge,
                    isAtBottomEdge = $window.pageYOffset >= sf.positionTop - sf.topEdge + duration;



                if (!sf.unboundProgress) {
                    if (isAtTopEdge && !isAtBottomEdge) {
                        sf.progress = ($window.pageYOffset - sf.positionTop + sf.topEdge) / duration;
                    }
                }
                else {
                    sf.progress = ($window.pageYOffset - sf.positionTop + sf.topEdge) / duration;
                }



                // scrolling top down or bottom up, entering hot area

                if (isAtTopEdge && !isAtBottomEdge && !fixed) {

                    fixed = true;


                    sf.stylesOriginal = {
                        'left': '-200vw',
                        'visibility': 'hidden'
                    };

                    sf.stylesClone = {
                        'top' : sf.topEdge + 'px',
                        'left': '0',
                        'visibility': 'visible'
                    };

                    sf.stylesOuter = {
                        'padding-top' : duration + 'px'
                    };
                }


                // scrolling bottom up, exiting hot area

                if (!isAtTopEdge && !isAtBottomEdge && fixed) {

                    fixed = false;


                    sf.stylesOriginal = {
                        'left': '0',
                        'visibility': 'visible'
                    };

                    sf.stylesClone = {
                        'top' : sf.topEdge + 'px',
                        'left': '-200vw',
                        'visibility': 'hidden'
                    };

                    sf.stylesOuter = {
                        'padding-top' : 0,
                        'padding-bottom' : duration + 'px'
                    };


                    if (!sf.unboundProgress) {
                        sf.progress = 0;
                    }
                }


                // scrolling top down, exiting hot area

                if (isAtBottomEdge && fixed) {

                    fixed = false;

                    sf.stylesOuter = {
                        'padding-bottom' : 0,
                        'padding-top' : duration + 'px'
                    };

                    sf.stylesOriginal = {
                        'left': '0',
                        'visibility': 'visible'
                    };

                    sf.stylesClone = {
                        'top' : sf.topEdge + 'px',
                        'left': '-200vw',
                        'visibility': 'hidden'
                    };



                    if (!sf.unboundProgress) {
                        sf.progress = 1;
                    }
                }


                $scope.$apply();
            };


            var unfix = function () {

                if (fixed) {

                    fixed = false;

                    sf.stylesOriginal = {
                        'left': '0',
                        'visibility': 'visible'
                    };

                    sf.stylesClone = {
                        'top' : sf.topEdge + 'px',
                        'left': '-200vw',
                        'visibility': 'hidden'
                    };


                    $scope.$apply();
                }
            };


            // start

            reqAnimationFrame(doScrollfix);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiParallax', uiParallax);


    /** @ngInject */
    function uiParallax ($timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-parallax/ui-parallax.html',
            scope: true,
            controller: UiParallaxController,
            link: linkFunc,
            controllerAs: 'vm',
            bindToController: {
                speed : "@"
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, vm){

            vm.ele = element[0].childNodes[0];

            var setProperties = function() {
                vm.offsetTop = vm.ele.offsetTop;
                vm.offsetHeight = vm.ele.offsetHeight;
            };


            $timeout(setProperties, 0);

            scope.$on('dom::changed', setProperties);

            vm.startParallaxing();

        }

        /** @ngInject */
        function UiParallaxController (reqAnimationFrame, $window, $scope) {

            var vm = this;

            if (!vm.speed) {
                vm.speed = 0.5;
            }

            vm.offsetTop = 0;
            vm.styles = {};

            vm.active = true;

            vm.startParallaxing = function() {

                reqAnimationFrame(function() {

                    var pixelsMoved = $window.pageYOffset - vm.offsetTop;

                    var x = 0;
                    var y = pixelsMoved * vm.speed * -1;

                    vm.styles.transform = "translate(" + x + "px, " + y + "px)";

                    if ($window.pageYOffset > vm.offsetHeight) {
                        if(vm.active) {
                            vm.active = false;
                            $scope.$apply();
                        }
                    }
                    else {
                        vm.active = true;
                    }

                    if (vm.active) {
                        $scope.$apply();
                    }
                });
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiMetaimage', uiMetaimage);


    /** @ngInject */
    function uiMetaimage () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-metaimage/ui-metaimage.html',
            scope: true,
            link: linkFunc,
            controller: UiMetaimageController,
            controllerAs: 'vm',
            bindToController: {
                headline: '@',
                image: '@',
                tile: '=',
                cropped : '=',
                group : '@',
                customButton : '@'
            },
            transclude: true
        };

        return directive;


        function linkFunc(scope, element, attrs, vm){

            vm.ele = element[0].childNodes[0];
        }

        /** @ngInject */
        function UiMetaimageController ($timeout, egalizeHeight) {

            var vm = this;


            vm.state = 'closed';
            vm.bodyHeight = 0;


            var eleInner;

            $timeout(function(){

                eleInner = vm.ele.querySelector('.ui-metaimg__body-inner');

                egalizeHeight.egalize(eleInner.offsetHeight, vm.group);

            },0);


            vm.toggle = function() {

                if (vm.state === 'closed') {

                    vm.state = 'open';

                    var heightOpened = eleInner.offsetHeight;

                    if (vm.group) {

                        vm.innerHeight = egalizeHeight.getHeightByGroup(vm.group);
                        heightOpened = egalizeHeight.getHeightByGroup(vm.group);
                    }

                    vm.bodyHeight = heightOpened;
                }
                else {

                    vm.state = 'closed';
                    vm.bodyHeight = 0;
                }
            };
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('digitHeiligenacht')
		.directive('uiMd', uiMd);


	/** @ngInject */
	function uiMd (Markdown) {
		var directive = {
			restrict: 'E',
			replace: true,
			// templateUrl: 'app/components/ui-img/ui-img.html',
			scope: {
				md: '='
			},
			link: linkFunc
		};

		return directive;


		function linkFunc (scope, element, attrs) {


			// create a pagedown converter - regular and sanitized versions are both supported
			var converter = new Markdown.Converter();


			// tell the converter to use Markdown Extra
			Markdown.Extra.init(converter);


			var unindent = function (text) {

				if (!text) { return text; }


				var lines = text
					.replace(/\t/g, '  ')
					.split(/\r?\n/);


				var min = null;


				var len = lines.length;


				for (var i = 0; i < len; i++) {

					var line = lines[i];

					var l = line.match(/^(\s*)/)[0].length;

					if (l === line.length) { continue; }

					min = (l < min || min === null) ? l : min;
				}


				if (min !== null && min > 0) {

					for (i = 0; i < len; i++) {

						lines[i] = lines[i].substr(min);
					}
				}


				return lines.join('\n');
			};


			var set = function (text) {

				text = unindent(text || '');

				element.html(converter.makeHtml(text));
			};


			set(scope.md || element.text() || '');


			if (attrs.md) {

				scope.$watch('md', set);
			}
		}
	}

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiMagnifier', uiMagnifier);


    /** @ngInject */
    function uiMagnifier ($timeout) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-magnifier/ui-magnifier.html',
            scope: true,
            controller: UiMagnifierController,
            controllerAs: 'mg',
            link : linkFunc,
            bindToController: {
                options : "=",
                progress : "="
            },
            transclude: false
        };

        return directive;


        function linkFunc(scope, ele, attrs, vm) {


            vm.setAttributes = function(){

                vm.boxWidth = ele[0].childNodes[0].offsetWidth;
                vm.boxHeight = ele[0].childNodes[0].offsetHeight;

                vm.calcOrigins();
            };


            $timeout(vm.setAttributes,0);

            scope.$on('dom::changed', vm.setAttributes);

        }


        /** @ngInject */
        function UiMagnifierController ($scope, _, easing) {


            var vm = this;


            var originsCalcedOnce = false;


            vm.styles = {
                circle : {},
                imgs : []
            };


            vm.calcOrigins = function(){


                // trying not to interrupt with later style attributes

                var circleHeight = vm.boxWidth,
                    topOffset = (vm.boxHeight / 2 - circleHeight/2);


                if(vm.options.magnifier.shift) {

                    topOffset = topOffset + vm.options.magnifier.shift[1];
                }

                vm.styles.circle.top = topOffset + 'px';



                _.each(vm.options.images, function(img, i){

                    // add if not existing

                    if (_.isUndefined(vm.styles.imgs[i])) {
                        vm.styles.imgs.push({});
                    }

                    // default starting point is center, unshift the topOffset from the box

                    vm.styles.imgs[i].top = (topOffset * -1) + 'px';
                    vm.styles.imgs[i].width = vm.boxWidth + 'px';


                    // get configured startings styles for images

                    if(!_.isUndefined(img.start) && !originsCalcedOnce) {

                        var scale = img.start.zoom || 0,
                            translateX = img.start.shift[0] || 0,
                            translateY = img.start.shift[1] || 0;

                        var transform = 'scale(' + (1 + scale) + ') translate(' + translateX + '%, ' + translateY + '%)';

                        vm.styles.imgs[i].transform = transform;
                        vm.styles.imgs[i]['-webkit-transform'] = transform;

                        originsCalcedOnce = true; // only do that once
                    }
                });
            };




            var setStyles = function(progress) {


                // calculating and applying styles to the magnifier and clip

                var mEffect = vm.options.magnifier.effect,
                    duration = mEffect.end - mEffect.start;


                switch (mEffect.type) {

                    case 'fadeIn' :

                        var opacity = cap( (progress - mEffect.start) / duration);

                        vm.styles.circle.opacity = opacity;

                        break;
                }


                // calculating and applying styles to the image elements

                _.each(vm.options.images, function(img, index){

                    var duration = img.effect.end - img.effect.start;

                    switch (img.effect.type) {

                        case 'zoomIn' :

                            var thisProgress = easing.easeOutQuad(cap( (progress - img.effect.start)/duration));

                            var scale = thisProgress * img.effect.depth,
                                translateX = thisProgress * img.effect.shift[0],
                                translateY = thisProgress * img.effect.shift[1];

                            var transform = 'scale(' + (1 + scale) + ') translate(' + translateX + '%, ' + translateY + '%)';

                            vm.styles.imgs[0].transform = transform;
                            vm.styles.imgs[0]['-webkit-transform'] = transform;

                            break;


                        case 'fadeIn' :

                            var opacity = cap( (progress - img.effect.start) / duration);

                            vm.styles.imgs[index].opacity = opacity;

                            break;
                    }
                });

            };



            var cap = function(num) {

                if(num < 0) {
                    num = 0;
                }
                if(num > 1) {
                    num = 1;
                }

                return num;
            };



            // initialization


            if (_.isUndefined(vm.options) || _.isUndefined(vm.options.images)) {

                return;
            }


            // these are the properties for ng-repeat
            vm.images = [];
            vm.baseImage = vm.options.images[0];

            _.each(vm.options.images, function(img){

                vm.images.push({
                    src : img.src,
                    format : img.format,
                    hqfactor : img.hqfactor
                });
            });



            $scope.$watch("mg.progress", function(newVal, oldVal){

                if (newVal !== oldVal) {

                    setStyles(newVal);
                }
            });
        }
    }

})();

(function () {
	'use strict';

	angular
		.module('digitHeiligenacht')
		.directive('uiImg', uiImg);


	/** @ngInject */
	function uiImg ($window, $log, _, imgix, HOSTS, onImagesLoaded, PNG_FORMAT) {
		var directive = {
			restrict: 'AE',
			template: '<img ng-attr-alt="{{imgAlt}}"/><div class="loading" ng-if="loading"><b></b><b></b><b></b></div>',
			scope: {
				image: '@',
				crop: '@',
				cover: '=',
				fixedHeight : '=',
				rect : '@',
				onLoad : '&',
				alt : '@',
				format : '@',
				background : '@',
				hqfactor : '@'
			},
			link: linkFunc
		};

		return directive;


		function linkFunc (scope, el) {



			// Select box

			var box = el[0];
			var img = box.children[0];


			if (_.isUndefined(scope.hqfactor)) {
				scope.hqfactor = 1;
			}


			// setup loading

			scope.loading = true;


			// tell the others when finished loading

			onImagesLoaded([img]).then(function () {

				if (!_.isUndefined(scope.onLoad) && _.isFunction(scope.onLoad)) {

					// avoid border arount image before load
					applyAltText();

					scope.$watch('alt', function(){
						applyAltText();
					});

					// remove loading  animation
					scope.loading = false;

					// execute onload expression
					scope.onLoad();
				}
			});


			var applyAltText = function(){

				if (!_.isUndefined(scope.alt)) {

					scope.imgAlt = scope.alt;
				}
			};


			var roundByPx = 10;


			var image = _.debounce(function () {


				if (!scope.image || _.isUndefined(scope.image)) {

					return;
				}


				// Round the given dimensions

				var width = Math.ceil(box.offsetWidth/roundByPx) * roundByPx * scope.hqfactor,
					height = Math.ceil(box.offsetHeight/roundByPx) * roundByPx  * scope.hqfactor;


				// Determine size

				var size = {
					w: scope.fixedHeight ? 'auto' : width,
					h: (scope.cover || scope.fixedHeight) ? height : 'auto'
				};



				if(size.w === 0 || size.h === 0) {
					return;
				}



				// negotiate file format

				var format = scope.format || 'jpg';

				if (scope.format === 'png' && PNG_FORMAT && !_.isUndefined(PNG_FORMAT)) {
					format = PNG_FORMAT;
				}


				// create opts

				var opts = {
					w: size.w,
					h: size.h,
					auto: 'format',
					fm: format,
					fit: 'crop',
					bg : scope.background || '',
					crop: scope.crop || 'faces',
					dpr: ($window.devicePixelRatio ? $window.devicePixelRatio : 1)
				};


				if (scope.rect) {
					opts.rect = scope.rect;
				}


				// Generate image path

				var uri = new imgix.URL(HOSTS.imgix + scope.image, opts);


				// Set as source

				uri.attachImageTo(img);
			}, 100);


			// Listen for resize

			var reImage = function(){

				image();
				scope.$apply();
			};


			angular.element($window).bind('resize', reImage);

			scope.$on('$destroy', function () {

				angular.element($window).off('resize', reImage);
			});



			// init
			scope.$watch('image', image);
		}
	}

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiFadeimage', uiFadeimage);


    /** @ngInject */
    function uiFadeimage (onImagesLoaded) {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-fadeimage/ui-fadeimage.html',
            scope: true,
            controller: UiFadeimageController,
            controllerAs: 'fi',
            bindToController: {
                progress : "=",
                nofade : '='
            },
            link : linkFunc,
            transclude: true
        };

        return directive;



        function linkFunc(scope, ele, attrs, vm) {


            vm.images = ele[0].querySelectorAll('img');
            vm.imageCount = vm.images.length;

            vm.setupParts();

            onImagesLoaded(vm.images).then(function () {

                vm.adjustContainerHeight();
            });

            scope.$on('dom::changed', vm.adjustContainerHeight);


            scope.$watch("fi.progress", function(newVal, oldVal){

                if (newVal !== oldVal) {

                    vm.setFade(newVal);
                }
            });
        }


        /** @ngInject */
        function UiFadeimageController ($scope, rfc4122, egalizeHeight, _) {

            var vm = this;


            vm.containerHeight = 0;

            vm.group = rfc4122.v4();


            vm.parts = {};


            // one part equals the time when one image fades out and the next crossfades in.
            // So we have 2 images = 1 part, 3 images = 2 parts, 4 images = 3 parts and so on

            vm.setupParts = function() {

                var partCount = vm.imageCount - 1;

                for (var i = 0; i < partCount; i++) {

                    vm.parts[i] = {
                        start : 1 / partCount * i,
                        end : 1 / partCount * (i+1) - 0.01
                    };
                }


                // reset image opacities
                // doing this via js cause we don't know how the dom is built up

                _.each(vm.images, function(image, index) {

                    var opacity = 0;
                    var i = parseInt(index, 10);

                    if(index === 0) {
                        opacity = 1;
                    }

                    vm.images[i].style.opacity = opacity;
                });
            };



            vm.setFade = function(progress) {


                _.each(vm.parts, function(part, index){

                    part.progress = (progress - part.start) / (part.end - part.start);


                    // limit to 0 and 1

                    if (part.progress < 0) {
                        part.progress = 0;
                    }
                    if (part.progress > 1) {
                        part.progress = 1;
                    }

                    var i = parseInt(index, 10);


                    // only apply styles when we are actually in the correct part

                    if (part.progress > 0 && part.progress <= 1) {

                        var thisOpacity = 1 - part.progress,
                            nextOpacity = part.progress;


                        // hart cut when nofade is given

                        if (vm.nofade) {

                            thisOpacity = 1;
                            nextOpacity = 0;

                            if (part.progress > 0.5) {
                                thisOpacity = 0;
                                nextOpacity = 1;
                            }
                        }

                        vm.images[i].style.opacity = thisOpacity;
                        vm.images[i+1].style.opacity = nextOpacity;
                    }

                    // last images sometimes does not go to zero, this fixes it
                    if (part.progress <= 0) {
                        vm.images[i+1].style.opacity = 0;
                    }
                });
            };



            vm.adjustContainerHeight = function() {


                egalizeHeight.resetGroup(vm.group);

                _.each(vm.images, function(img){

                    egalizeHeight.egalize(img.offsetHeight, vm.group);
                });

                vm.containerHeight = egalizeHeight.getHeightByGroup(vm.group);
            };
        }
    }

})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .directive('uiDropmore', uiDropmore);


    /** @ngInject */
    function uiDropmore () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-dropmore/ui-dropmore.html',
            scope: true,
            controller: UiDropmoreController,
            controllerAs: 'dm',
            bindToController: {
                aniDir : "@?",
                startPos : "=?",
                endPos : "=?",
                customButton : '@'
            },
            transclude: true
        };

        return directive;


        /** @ngInject */
        function UiDropmoreController ($element, $window, BREAKPOINTS) {

            var vm = this;



            vm.buttonStartPos = vm.startPos;
            vm.buttonEndPos = vm.endPos;


            // where the button sits when closed  in rem from the middle
            if (!vm.startPos || $window.innerWidth < BREAKPOINTS.maxWidthMobile) {

                vm.buttonStartPos = 0; // default and mobile
            }


            // where the button sits when opened in rem from the middle

            if (!vm.endPos || $window.innerWidth < BREAKPOINTS.maxWidthMobile) {

                vm.buttonEndPos = 8.6; // default and mobile
            }


            vm.state = 'closed';


            vm.innerHeight = 0;


            vm.toggle = function() {

                updateInnerHeight();

                if(vm.state === 'open') {
                    vm.state = 'closed';
                    vm.forcedEndPos = false;
                }
                else {
                    vm.state = 'open';
                    vm.forcedEndPos = vm.buttonEndPos;
                }
            };


            var updateInnerHeight = function(){

                var innerEle = $element[0].querySelector('.ui-dropmore__inner');
                vm.innerHeight = innerEle.offsetHeight;
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiCheckDevice', uiCheckDevice);


    /** @ngInject */
    function uiCheckDevice () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-check-device/ui-check-device.html',
            scope: true,
            controller: UiCheckDeviceController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        /** @ngInject */
        function UiCheckDeviceController ($document, $log, bowser) {

            var vm = this;

            vm.testvar = true;


            var detectFeatures = function() {

                var hasAllFeatures = $document[0].createElement("detect").style.borderImage === "",
                    // isIE11 = bowser.msie && bowser.version.indexOf('11.') !== -1,
                    isIE10 = bowser.msie && bowser.version.indexOf('10.') !== -1;


                if (hasAllFeatures && !isIE10) {

                    vm.features = true;
                }
                else {

                    vm.features = false;
                }
            };

            vm.ratio = true;

            // initialization

            detectFeatures();
        }
    }
})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .directive('uiChapterheading', uiChapterheading);


    /** @ngInject */
    function uiChapterheading () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-chapterheading/ui-chapterheading.html',
            scope: true,
            controller: UiChapterheadingController,
            controllerAs: 'vm',
            transclude: true,
            bindToController: {
                img : '=',
                caption: '@',
                timeStart : '=',
                timeEnd : '='
            }
        };

        return directive;


        /** @ngInject */
        function UiChapterheadingController ($log, $scope, _, $element, reqAnimationFrame, $window) {

            var vm = this;


            vm.styles = {};


            vm.progress = 0;


            // setup the progressing measurement

            var progressor = $element[0].querySelector('.ui-chapterheading__progressor');


            // this is measured in viewport height (vh)

            var start = 60,
                stop = -100;


            start = start / 100 * $window.innerHeight;
            stop = stop / 100 * $window.innerHeight;



            var progress = function () {

                var pos = progressor.getBoundingClientRect().top;


                if(pos <= start && pos >= stop) {
                    vm.progress = 1 - (pos + Math.abs(stop)) / (start + Math.abs(stop));
                }

                if(pos > start) {
                    vm.progress = 0;
                }
                if(pos < stop) {
                    vm.progress = 1;
                }

                var val = vm.progress;

                if(val > 0 && val < 1) {
                    vm.active = true;
                    setStyles(val);

                }
                else if(vm.active) {
                    vm.active = false;
                    setStyles(val);
                }

            };


            // init

            reqAnimationFrame(progress);



            // time defines a progress-point between 0 and 1

            // x and y are multipliers for transform x and y


            var keyframes_background = [
                {
                    time : 0,
                    x : -1,
                    y : 0
                },
                {
                    time : 0.75,
                    x : 0,
                    y : 0
                }
            ];

            var keyframes_inner = [
                {
                    time : 0,
                    x : -0.5,
                    y : 0,
                    opacity : 0

                },
                {
                    time : 0.33,
                    x : -0.33,
                    y : 0,
                    opacity: 1
                },
                {
                    time : 1,
                    x : 0,
                    y : 0,
                    opacity : 1
                }
            ];



            var setStyles = function (val) {

                vm.styles.background = getStyles(val, keyframes_background);
                vm.styles.inner = getStyles(val, keyframes_inner);

                $scope.$apply();
            };




            var getStyles = function (p, keyframes) {


                var shiftX = 0,
                    shiftY = 0,
                    opacity = 0;


                var deltaX,
                    deltaY,
                    deltaOpacity;


                var hasXShift = !_.isUndefined(keyframes[0].x),
                    hasYShift = !_.isUndefined(keyframes[0].y),
                    hasOpacityChange = !_.isUndefined(keyframes[0].opacity);



                _.each(keyframes, function(kf, i){

                    var nextFrame = keyframes[i + 1] || keyframes[keyframes.length - 1];


                    if (hasXShift) {
                        deltaX = nextFrame.x - kf.x;
                    }

                    if (hasYShift) {
                        deltaY = nextFrame.y - kf.y;
                    }

                    if(hasOpacityChange) {
                        deltaOpacity = nextFrame.opacity - kf.opacity;
                    }


                    if (p >= kf.time && p <= nextFrame.time) {

                        var partProgress = (p - kf.time) / (nextFrame.time - kf.time);

                        if (hasXShift) {
                            shiftX = kf.x + partProgress * deltaX;
                        }
                        if (hasYShift) {
                            shiftY = kf.y + partProgress * deltaY;
                        }
                        if (hasOpacityChange) {
                            opacity = kf.opacity + partProgress * deltaOpacity;
                        }
                    }


                });


                // everything outer bounce

                if (p <= 0 ) {
                    shiftX = keyframes[0].x || 0;
                    shiftY = keyframes[0].y || 0;
                    opacity = keyframes[0].opacity || 0;
                }

                if (p >= 1 ) {
                    shiftX = keyframes[keyframes.length - 1].x || 0;
                    shiftY = keyframes[keyframes.length - 1].y || 0;
                    opacity = keyframes[keyframes.length - 1].opacity || 1;
                }


                var css = {
                    'transform' : 'translate(' + easeInCubic(shiftX) * 100 + '%, ' + easeInCubic(shiftY) * 100 + '%)'
                };


                if (hasOpacityChange) {
                    css.opacity = opacity;
                }


                return css;
            };



            var easeInCubic = function(t) {

                return Math.pow(t,3);
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiButton', uiButton);


    /** @ngInject */
    function uiButton () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/ui-button/ui-button.html',
            scope: true,
            controller: UiButtonController,
            controllerAs: 'button',
            link: linkFunc,
            bindToController: {
                type: '@',
                ref: '@',
                state: '@',
                custom : '@',
                mod : '@'
            }
        };

        return directive;


        function linkFunc (scope, ele, attr, vm) {

            vm.link = ele[0].querySelector("a");
        }


        /** @ngInject */
        function UiButtonController () {

            var vm = this;


            if (!vm.type && !vm.custom) {

                vm.type = 'default';
            }


            if (!vm.state) {

                vm.state = 'tbd';
            }

            if (!vm.mod) {

                vm.mod = 'none';
            }


            // if this is no real link, unfocus after click

            vm.blurCond = function () {

                if (!vm.ref) {

                    vm.link.blur();
                }
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('uiAudioplayer', uiAudioplayer);


    /** @ngInject */
    function uiAudioplayer () {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/components/ui-audioplayer/ui-audioplayer.html',
            scope: true,
            controller: UiAudioplayer,
            controllerAs: 'vm',
            bindToController: {
                audio: '@',
                audiotitle : '@',
                customPlayButton : '@',
                customPauseButton : '@'
            }
        };

        return directive;


        /** @ngInject */
        function UiAudioplayer ($scope, $element, $rootScope, _) {

            var vm = this;

            vm.isPlaying = false;

            vm.play = function(){


                // tell the other audioplayers, that we are playing now

                $rootScope.$broadcast('audioplayer::playing');

                $scope.player.play();
                vm.isPlaying = true;
            };


            vm.pause = function() {

                $scope.player.pause();
                vm.isPlaying = false;
            };


            // if another audioplayer starts playing

            $scope.$on('audioplayer::playing', function(){

                if(vm.isPlaying) {
                    vm.pause();
                }
            });


            // wait for player


            $scope.$watch('player', function(val){

                if (!_.isUndefined(val) ) {
                    initPlayer();
                }
            });





            var initPlayer = function() {


                $scope.$watch('player.currentTime', function(){

                    updateProgress();
                });


                $scope.$watch('player.ended', function(){

                    if( !_.isUndefined($scope.player.currentTime)) {
                        resetPlayer();
                    }
                });
            };


            vm.progress = 0;

            var updateProgress = function() {

                if ($scope.player.duration && $scope.player.currentTime) {

                    vm.progress = $scope.player.currentTime / $scope.player.duration;

                }
            };


            var resetPlayer = function() {

                vm.pause();
                $scope.player.seek(0);
                vm.progress = 0;
            };



            vm.jumpToTime = function($event){

                var progressEle = $element[0].querySelector('.ui-audioplayer__progress');

                var clientX = $event.clientX || $event.touches[0].clientX,
                    elementStart = progressEle.getBoundingClientRect().left,
                    elementLength = progressEle.getBoundingClientRect().width;


                var clickPos = clientX - elementStart,
                    toTimePercentage = clickPos / elementLength,
                    newTime = $scope.player.duration * toTimePercentage;

                $scope.player.seek(newTime);
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .service('sharing', sharing);

    /** @ngInject */
    function sharing($rootScope, $q) {

        var links = {};

        var data = {
            'url' : '',
            'hashtags' : '',
            'text' : '',
            'mailsubject' : '',
            'mailbody' :  '',
            'whatsapptext' : '',
            'twittertext' : ''
        };


        var setup = function(input) {

            var deferred = $q.defer();

            data = input;

            links = {
                facebook : 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(data.url),
                pinterest : 'https://pinterest.com/pin/create/link/?url=' + encodeURIComponent(data.url) + '&description=' + encodeURIComponent(data.text),
                twitter : 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(data.twittertext) + '&url=' + encodeURIComponent(data.url) + '&original_referer=' + encodeURIComponent(data.url),
                mail : 'mailto:?subject=' + encodeURIComponent(data.mailsubject) + '&body=' + encodeURIComponent(data.mailbody),
                gplus : 'https://plus.google.com/share?url=' + encodeURIComponent(data.url),
                whatsapp : 'whatsapp://send?text=' + encodeURIComponent(data.whatsapptext)
            };

            deferred.resolve(links);

            return deferred.promise;
        };


        return {
            setup : setup
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('sameHeight', sameHeight);


    /** @ngInject */
    function sameHeight (egalizeHeight, $timeout, onImagesLoaded, _) {
        var directive = {
            restrict: 'A',
            scope: {
                sameHeight : "@"
            },
            link: function(scope, ele) {

                var group = scope.sameHeight;


                var getHeight = function() {

                    $timeout(function(){

                        var images = ele[0].querySelectorAll('img');

                        if( !_.isEmpty(images) ) {

                            onImagesLoaded(images).then(function () {

                                egalizeHeight.egalize(ele[0].offsetHeight, group);
                            });
                        }
                        else {

                            egalizeHeight.egalize(ele[0].offsetHeight, group);
                        }

                    },0);
                };


                getHeight();


                egalizeHeight.onChange(function(groups){

                    if (groups[group]) {
                        ele[0].style.minHeight = groups[group].height + 'px';
                    }
                });
            }
        };

        return directive;
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .service('reqAnimationFrame', reqAnimationFrame);

    /** @ngInject */
    function reqAnimationFrame($window, $timeout, rfc4122, _) {

        // Detect request animation frame
        var reqAniFrame = $window.requestAnimationFrame ||
            $window.webkitRequestAnimationFrame ||
            $window.mozRequestAnimationFrame ||
            $window.msRequestAnimationFrame ||
            $window.oRequestAnimationFrame ||
            // IE Fallback, you can even fallback to onscroll
            function(callback){ $timeout(callback, 1000/60) ; };


            var AFLoopCallbacks = {};

            var collect = function(fn){
                var uuid = rfc4122.v4();
                AFLoopCallbacks[uuid] = fn;
            };

            var start = function(){

                var lastPos = $window.pageYOffset;

                var loop = function() {

                    if ($window.pageYOffset === lastPos) {
                        reqAniFrame(loop);
                        return false;
                    }
                    else{
                        lastPos = $window.pageYOffset;
                    }

                    _.each(AFLoopCallbacks, function(fn){
                        fn();
                    });

                    reqAniFrame(loop);

                };

                loop();

            };

            // start the loop
            $timeout(start, 0);


        return collect;


    }


})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .directive('remscaling', remscaling);


    /** @ngInject */
    function remscaling ($window, $timeout) {

        var directive = {
            restrict: 'A',
            scope: {
                remscaling : '=?',
                preservedRatio : '='
            },
            controller: RemscalingController,
            link: RemscalingLinkFunc,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;


        function RemscalingLinkFunc (scope, el, attr, vm) {

            vm.rootElement = el[0];

            var baseFontSize = $window.getComputedStyle(vm.rootElement)['font-size'];
            vm.baseFontSize = parseInt(baseFontSize, 10);

            $timeout(function() {

                vm.calculateRem();
            }, 0);


            angular.element($window).bind("resize", vm.calculateRem);
        }


        /** @ngInject */
        function RemscalingController ($rootScope, BREAKPOINTS) {

            var vm = this;


            var defaultWidthDesktop = BREAKPOINTS.defaultWidthDesktop || 1280,
                maxWidthDesktop = BREAKPOINTS.maxWidthDesktop || 1440,
                defaultWidthMobile = BREAKPOINTS.defaultWidthMobile || 320,
                maxWidthMobile = BREAKPOINTS.maxWidthMobile - 1 || 539;

            var maxWidth = maxWidthDesktop,
                minWidth = defaultWidthMobile;


            vm.calculateRem = function () {


                var currentWidth = $window.innerWidth,
                    currentHeight = $window.innerHeight,
                    newWidth = currentWidth;


                // limit on small widths

                if (currentWidth <= minWidth) {
                    newWidth = minWidth;
                }



                // limit on large widths

                if (currentWidth >= maxWidth) {
                    newWidth = maxWidth;
                }



                // check if we are on mobile or desktop

                if (currentWidth > maxWidthMobile) {

                    vm.defaultWidth = defaultWidthDesktop;
                }
                else {

                    vm.defaultWidth = defaultWidthMobile;
                }



                // also scale when height is too low and directive is ordered to preserve a viewport-ratio

                if (vm.preservedRatio && vm.preservedRatio > 0) {

                    var minHeight = currentWidth / vm.preservedRatio;

                    if (currentHeight < minHeight) {

                        newWidth = currentHeight * vm.preservedRatio;
                    }
                }


                applyWidth(newWidth);
            };



            var applyWidth = function(width){

                var fontSize = width / vm.defaultWidth * vm.baseFontSize;

                vm.rootElement.style.fontSize = fontSize + 'px';

                $rootScope.baseFontSize = fontSize;
            };
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .service('overlayState', overlayState);

    /** @ngInject */
    function overlayState($rootScope, $document) {


        var set = function (on) {

            if (on === true) {

                $rootScope.isOverlay = true;

                angular.element($document[0].body).bind('touchmove', function(e){

                    e.preventDefault();
                });
            }
            else {

                $rootScope.isOverlay = false;

                angular.element($document[0].body).unbind('touchmove');
            }
        };


        var get = function () {

            return $rootScope.isOverlay;
        };


        return {
            set : set,
            get : get
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('onLastRepeat', onLastRepeat);


    /** @ngInject */
    function onLastRepeat ($timeout) {
        var directive = {
            restrict: 'A',
            scope: true,
            controller: OnLastRepeatController,
            link: linkFunc,
            controllerAs: 'vm',
            bindToController: {
                onLastRepeat : '&'
            }
        };

        function linkFunc(scope, ele, attr, vm) {

            if (scope.$last) {

                $timeout(function(){
                    vm.onLastRepeat();
                },1);

            }
        }

        function OnLastRepeatController () {

            var vm = this;

            vm.testvar = true;

        }


        return directive;

    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .service('onImagesLoaded', onImagesLoaded);

    /** @ngInject */
    function onImagesLoaded($timeout, $q, _) {


        var run = function (images) {

            var loadedImages = 0;

            var deferred = $q.defer();


            if (angular.isUndefined(images) || images.length < 1) {

                deferred.reject('No images defined or found');
            }


            $timeout(function () {

                _.each (images, function (i) {

                    if (i.src && i.src !== "" && i.complete) {

                        loadedImages++;

                        if (loadedImages === images.length) {

                            deferred.resolve('Images loaded');
                        }
                    }
                    else {

                        i.addEventListener('load', function (){

                            loadedImages++;

                            if (loadedImages === images.length) {

                                deferred.resolve('Images loaded');
                            }
                        });
                    }
                });
            },1);


            return deferred.promise;
        };


        return run;


    }


})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .service('language', language);

    /** @ngInject */
    function language(LANGUAGES, $translate, _, $stateParams, store, $log, $rootScope) {



        var langAvailable = function (l) {

            return _.contains(LANGUAGES, l);
        };



        var set = function (lang) {


            // switch langauge via method

            if (!_.isUndefined(lang) && langAvailable(lang)) {

                $translate.use(lang).then(function(lang){

                    $log.debug('LANG actively set to ' + lang);
                    store.set('appLanguage', lang);

                    $rootScope.$broadcast('dom::changed');
                    $rootScope.$broadcast('lang::set');
                });

                return lang;
            }


            // switching language when url says so

            else if (!_.isUndefined($stateParams.lang) && langAvailable($stateParams.lang)) {

                $translate.use($stateParams.lang).then(function(lang){

                    $log.debug('URL defines language ' + lang);
                    store.set('appLanguage', lang);
                    $rootScope.$broadcast('lang::set');
                });

                return $stateParams.lang;
            }

            // set language based on local storage

            else if (store.get('appLanguage') && langAvailable(store.get('appLanguage')))  {

                $log.debug('SAVED LANGUAGE found, using ' + store.get('appLanguage'));

                $translate.use(store.get('appLanguage')).then(function(){

                    $rootScope.$broadcast('lang::set');
                });

                return store.get('appLanguage');
            }


            $log.debug('using default language');
            $rootScope.$broadcast('lang::set');

            var defaultLang = $translate.proposedLanguage() || $translate.use();
            return defaultLang;
        };



        var get = function () {

            return $translate.use();
        };



        return {
            set : set,
            get : get
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .service('egalizeHeight', egalizeHeight);

    /** @ngInject */
    function egalizeHeight(_) {

        var groups = {};

        var callbacks = [];


        var egalize = function (height, group) {


            if (_.isUndefined(group)) {
                // when theres no group, theres nothing to do
                return;
            }

            if (groups[group] && groups[group].height) {

                // when theres a group and a existing height, compare
                if (height > groups[group].height ) {

                    groups[group].height = height;
                }
            }
            else {

                // when this is the first time, create group and first height
                groups[group] = {
                    'height' : height
                };
            }


            _.each(callbacks, function(cb){

                if(_.isFunction(cb)) {
                    cb(groups);
                }
            });
        };


        var getHeightByGroup = function(group) {

            if(groups[group]) {
                return groups[group].height;
            }
        };



        var onChange = function(cb) {

            if(_.isFunction(cb)) {
                callbacks.push(cb);
            }
        };


        var resetGroup = function(group) {

            if (_.isUndefined(group)) {
                // when theres no group, theres nothing to do
                return;
            }

            if (groups[group] && groups[group].height) {

                groups[group].height = 0;
            }
        };


        return {
            egalize : egalize,
            getHeightByGroup : getHeightByGroup,
            onChange : onChange,
            resetGroup : resetGroup
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .service('easing', easing);

    /** @ngInject */
    function easing() {


        var easingFunctions = {
          // no easing, no acceleration
          linear: function (t) { return t },
          // accelerating from zero velocity
          easeInQuad: function (t) { return t*t },
          // decelerating to zero velocity
          easeOutQuad: function (t) { return t*(2-t) },
          // acceleration until halfway, then deceleration
          easeInOutQuad: function (t) { return t<.5 ? 2*t*t : -1+(4-2*t)*t },
          // accelerating from zero velocity
          easeInCubic: function (t) { return t*t*t },
          // decelerating to zero velocity
          easeOutCubic: function (t) { return (--t)*t*t+1 },
          // acceleration until halfway, then deceleration
          easeInOutCubic: function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 },
          // accelerating from zero velocity
          easeInQuart: function (t) { return t*t*t*t },
          // decelerating to zero velocity
          easeOutQuart: function (t) { return 1-(--t)*t*t*t },
          // acceleration until halfway, then deceleration
          easeInOutQuart: function (t) { return t<.5 ? 8*t*t*t*t : 1-8*(--t)*t*t*t },
          // accelerating from zero velocity
          easeInQuint: function (t) { return t*t*t*t*t },
          // decelerating to zero velocity
          easeOutQuint: function (t) { return 1+(--t)*t*t*t*t },
          // acceleration until halfway, then deceleration
          easeInOutQuint: function (t) { return t<.5 ? 16*t*t*t*t*t : 1+16*(--t)*t*t*t*t }
        }

        return easingFunctions;

    }


})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('digitFooter', digitFooter);


    /** @ngInject */
    function digitFooter () {

        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/digit-footer/digit-footer.html',
            scope: true,
            controller: DigitFooterController,
            controllerAs: 'vm',
            bindToController: {
                showCopyrights : '='
            }
        };

        return directive;


        /** @ngInject */
        function DigitFooterController (_, $timeout, $element, reqAnimationFrame, $window, $scope) {


            var vm = this;

            // initial
            vm.context = 'bottom';

            vm.showSidebar = false;


            var setupContainerHeight = function () {

                var inner = $element[0].querySelector('.digit-footer__inner-content');

                vm.outerHeight = inner.offsetHeight;
            };


            var setContext = function () {

                var threshold = $window.innerHeight * 1.2;

                if ($element[0].getBoundingClientRect().top < threshold) {

                    if (vm.context !== 'bottom') {
                        vm.context = 'bottom';
                        $scope.$apply();
                    }
                }
                else {

                    if (vm.context !== 'sidebar') {
                        vm.context = 'sidebar';
                        $scope.$apply();
                    }
                }

            };


            $timeout(function(){

                setupContainerHeight();

                setContext();
                reqAnimationFrame(setContext);

            }, 100);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('digitBrand', digitBrand);


    /** @ngInject */
    function digitBrand () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/digit-brand/digit-brand.html',
            scope: true,
            controller: DigitBrandController,
            controllerAs: 'brand',
            bindToController: {
                ref: '@',
                newWindow : '='
            }
        };

        return directive;


        /** @ngInject */
        function DigitBrandController () {

            var vm = this;

            vm.testvar = true;
        }
    }

})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .directive('digitBody', digitBody);


    /** @ngInject */
    function digitBody () {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/digit-body/digit-body.html',
            scope: true,
            controller: DigitBodyController,
            controllerAs: 'digit',
            bindToController: {
                colors : '='
            }
        };

        return directive;


        /** @ngInject */
        function DigitBodyController () {


            var vm = this;



            // C O N T E N T   F O R   I M A G E C A R O U S E L S   A N D   Z O O M I M A G E S

            vm.magnifierMariaOptions = {

                'magnifier' : {
                    shift : [0,-80],
                    effect : {
                        type : 'fadeIn',
                        start : 0,
                        end   : 0.2
                    }
                },

                'images' : [
                    {
                        src : 'maria_neu_d108605_copyright.png',
                        format : 'png',
                        hqfactor : 1.8,
                        effect : {
                            start : 0.2,
                            end   : 0.5,
                            type : 'zoomIn',
                            depth : 1,
                            shift : [0,4]
                        }
                    },
                    {
                        src : 'maria_neu_d108606_copyright.png',
                        format : 'png',
                        hqfactor : 1.8,
                        start : {
                            zoom : 1,
                            shift : [0,4]
                        },
                        effect : {
                            start : 0.5,
                            end   : 1,
                            type : 'fadeIn'
                        }
                    }
                ]
            };



            vm.magnifierKoelnOptions = {

                'magnifier' : {
                    shift : [0,0],
                    effect : {
                        type : 'fadeIn',
                        start : 0,
                        end   : 0.2
                    }
                },

                'images' : [
                    {
                        src : 'rba_c002341b_revised.png',
                        format : 'png',
                        hqfactor : 1.5,
                        effect : {
                            start : 0.2,
                            end   : 1,
                            type : 'zoomIn',
                            depth : 0.6,
                            shift : [10,7]
                        }
                    }
                ]
            };


            vm.zoomImg1 = {
                width : 2490,
                height: 2000,
                maxZoom : 1.6,
                offset : {
                    x : -200,
                    y : 750
                },
                tiles : "assets/dzi/bilddatei_rom_vatikanische_museen_inv_40137.dzi"
            };

            vm.zoomImg2 = {
                width : 2544,
                height: 2835,
                maxZoom : 1.8,
                offset : {
                    x : -100,
                    y : -500
                },
                tiles : "assets/dzi/312_tucheraltar.dzi"
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('broadcastDomchange', broadcastDomchange);


    /** @ngInject */
    function broadcastDomchange ($rootScope, $document, $window, _) {
        var directive = {
            restrict: 'A',
            scope: true,
            link: function(scope) {

                var fireDomchangeNotification = function() {

                    $rootScope.$broadcast('dom::changed');
                };


                // watch for resized bodyheight due to new elements and stuff
                // only fired when $apply() is running (and rightly so)

                scope.$watch(function(){

                    return $document[0].body.offsetHeight;

                }, function(newVal, oldVal){

                    if(newVal !== oldVal) {
                        fireDomchangeNotification();
                    }
                });

                // watch for resized window

                var debouncedFireDomchangeNotification = _.debounce(fireDomchangeNotification, 150);

                angular.element($window).bind('resize', debouncedFireDomchangeNotification);

                scope.$on('$destroy', function() {

                    angular.element($window).off('resize', debouncedFireDomchangeNotification);
                });

            }
        };

        return directive;

    }

})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .directive('bowserClasses', bowserClasses);


    /** @ngInject */
    function bowserClasses (bowser) {

        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;


        function linkFunc (scope, el) {

            var classes = [];


            // browsers

            if (bowser.msie) {
                classes.push('msie');
            }

            if (bowser.chrome) {
                classes.push('chrome');
            }

            if (bowser.firefox) {
                classes.push('firefox');
            }

            if (bowser.msedge) {
                classes.push('msedge');
            }

            if (bowser.safari) {
                classes.push('safari');
            }

            if (bowser.opera) {
                classes.push('opera');
            }


            // os

            if (bowser.mac) {
                classes.push('mac');
            }

            if (bowser.linux) {
                classes.push('linux');
            }

            if (bowser.chromeos) {
                classes.push('chromeos');
            }

            if (bowser.android) {
                classes.push('android');
            }

            if (bowser.ios) {
                classes.push('ios');
            }

            if (bowser.firefoxos) {
                classes.push('firefoxos');
            }

            var osVersion = bowser.osversion ? bowser.osversion.replace('.', '-') : '';


            // browser names and version

            var browserName = bowser.name.replace(' ', '_').toLowerCase();
            var browserVersion = bowser.version.replace('.', '_');


            // add all those classes

            el.addClass(classes.join(', '))
                .addClass(browserName)
                .addClass('ver-' + browserVersion);

            if (osVersion !== '') {
                el.addClass('os-' + osVersion);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .controller('MainController', MainController);


    /** @ngInject */
    function MainController ($scope, language, $rootScope, $translatePartialLoader, $document, $timeout, sharing, $translate, HOSTS) {

        var vm = this;



        vm.colors = {
            primary : '#B4975A',
            secondary : '#003B6A',
            highlight : '#700008'
        };

        // L A N G U A G E S

        vm.currentLanguage = language.set(); // determines default language to use and returns it



        // F O O T N O T E   H A N D L I N G

        vm.gotoFootnote = function(e) {

            e.preventDefault();

            vm.showCopyrights = true;


            var href = e.target.getAttribute('href'),
                target = angular.element($document[0].querySelector(href));


            $timeout(function(){

                $document.scrollToElementAnimated(target);
            }, 100);
        };




        $scope.$on('lang::set', function() {


            // A D D  T R A N S L A T I O N   P A R T S

            $translatePartialLoader.addPart('body');
            $translatePartialLoader.addPart('copyrights');


            // S H A R I N G  D I A L O G S

            $translate([
                'SHARING_URL',
                'SHARING_HASHTAGS',
                'SHARING_TEXT',
                'SHARING_MAILSUBJECT',
                'SHARING_MAILBODY',
                'SHARING_WHATSAPPTEXT',
                'SHARING_TWITTERTEXT',
                'META_IMAGE_SRC'
            ]).then(function(t){

                sharing.setup({
                    'url' : t.SHARING_URL,
                    'hashtags' : t.SHARING_HASHTAGS,
                    'text' : t.SHARING_TEXT,
                    'mailsubject' : t.SHARING_MAILSUBJECT,
                    'mailbody' : t.SHARING_MAILBODY,
                    'whatsapptext' : t.SHARING_WHATSAPPTEXT,
                    'twittertext' : t.SHARING_TWITTERTEXT
                }).then(function(links){

                    vm.sharing = links;
                });

                $rootScope.metaImgSrc = HOSTS.imgix + t.META_IMAGE_SRC;
            });
        });
    }

})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .controller('LightboxController', LightboxController);


    /** @ngInject */
    function LightboxController ($stateParams, $state, _, $translate, $document) {

        var vm = this;

        if (_.isUndefined($stateParams.url)) {

            $state.go('^');
        }

        vm.url = $stateParams.url;


        if ($stateParams.caption) {

            vm.caption = String($stateParams.caption);
        }


        if ($stateParams.imageFormat) {

            vm.imageFormat = String($stateParams.imageFormat);
        }



        vm.close = function(){

            $state.go('^');
        };


        // L I G H T B O X   C L O S E   O N   E S C A P E

        angular.element($document).bind('keydown keypress', function (event) {

            if (event.which === 27) {

                vm.close();
            }
        });

    }
})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .run(runBlock);


    /** @ngInject */
    function runBlock (FastClick, $window, $document, $log, $rootScope, $translate, sharing, HOSTS, Modernizr, overlayState, BREAKPOINTS, _) {


        // don't let the browser get in our way

        // $window.history.scrollRestauration = 'manual';



        // Apply Fastclick

        FastClick.attach($document[0].body);


        // Check for outdated Browser

        $rootScope.isOutdatedBrowser = !Modernizr.csstransforms3d;



        // refresh translation tables when new partial is added (e.g. via submodule)

        var translatePartialLoaderCallback = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {

            $log.debug('TRANSLATE: refreshing tables');
            $translate.refresh();
        });

        $rootScope.$on('$destroy', translatePartialLoaderCallback);


        var stateChangeSuccessCallback = $rootScope.$on('$stateChangeSuccess', function (event, toState) {


            // handle overlays, e.g. "preview"

            if (angular.isDefined(toState.data) && toState.data.isOverlay) {

                overlayState.set(true);
            }
            else {

                overlayState.set(false);
            }
        });

        $rootScope.$on('$destroy', stateChangeSuccessCallback);


        // check device and device changes


        var checkDevice = function() {

            var deviceBefore = $rootScope.device;

            $rootScope.isTouch = Modernizr.touch;

            if($window.innerWidth <= BREAKPOINTS.maxWidthMobile) {
                $rootScope.device = "mobile";
            }
            else {
                $rootScope.device = "desktop";
            }

            if($rootScope.device !== deviceBefore) {
                $log.log('device is now: ' + $rootScope.device);
                $rootScope.$broadcast('device::changed');
            }
        };


        checkDevice();


        var debouncedCheckDevice = _.debounce(checkDevice, 150);


        angular.element($window).bind('resize', debouncedCheckDevice);


        $rootScope.$on('$destroy', function(){

            angular.element($window).unbind('resize', checkDevice);
        });



        $log.debug('runBlock end');
    }
})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .config(routerConfig);


    /** @ngInject */
    function routerConfig ($stateProvider, $urlRouterProvider, LANGUAGES) {

        $stateProvider
            .state('main', {
                url: '/{lang:' + LANGUAGES.join('|') + '}',
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main',
                cache: false,
                params: {
                    lang: LANGUAGES[0]
                }
            })
            .state('main.lightbox', {
                url: '/zoom/:url',
                data:  {
                    isOverlay: true
                },
                params : {
                    caption : false,
                    imageFormat : false
                },
                templateUrl: 'app/lightbox/lightbox.html',
                controller: 'LightboxController',
                controllerAs: 'lightbox',
                cache: false
            });

        $urlRouterProvider.otherwise('/');
    }

})();

/* global _:false */
/* global FastClick:false */
/* global imgix:false */
/* global Markdown:false */
/* global Modernizr:false */
(function () {
    'use strict';

    angular
        .module('digitHeiligenacht')
        .constant('_', _)
        .constant('FastClick', FastClick)
        .constant("Modernizr", Modernizr)
        .constant('imgix', imgix)
        .constant('PNG_FORMAT', 'png8')
        .constant('Markdown', Markdown)
        .constant('FORCE_LINEAR', false)
        .constant('HOSTS', {
            // imgix: 'https://stdldigits.imgix.net/'
            imgix : 'http://dne.staedel.de/_api/_520/img/heiligenacht/'
        })
        .constant('BREAKPOINTS', {
            maxWidthMobile: 600,
            defaultWidthDesktop : 1024
        })
        .constant('LANGUAGES',['de','en']);
})();

(function () {
    'use strict';

    angular
    .module('digitHeiligenacht')
    .config(config);


    /** @ngInject */
    function config ($locationProvider, $logProvider, HOSTS, RestangularProvider, LANGUAGES, $translateProvider, $translatePartialLoaderProvider, $windowProvider, $compileProvider) {


        // Enable HTML5 mode

        $locationProvider.html5Mode(true);


        // Disabled log

        $logProvider.debugEnabled(false);


        // API base URI

        RestangularProvider.setBaseUrl(HOSTS.api);


        // making whatsapp as url possible

        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|whatsapp):/);



        // Configure translation provider and partial loader

        $translatePartialLoaderProvider.addPart('global');

        $translateProvider.useSanitizeValueStrategy(null);

        $translateProvider.useLoader('$translatePartialLoader', {

            urlTemplate: 'app/i18n/{part}/{lang}.json'
        });

        $translateProvider.determinePreferredLanguage(function(){

            var userLang;

            var $window = $windowProvider.$get();

            // for modern browsers
            if ($window.navigator.language) {
                userLang = ($window.navigator.language).split('-')[0];
            }
            // for ie < 11
            else if($window.navigator.browserLanguage) {
                userLang = ($window.navigator.browserLanguage).split('-')[0];
            }

            return userLang;
        });

        $translateProvider.fallbackLanguage(LANGUAGES[0]);
    }




    // M E D I A   P L A Y E R

    angular.module('digitHeiligenacht')
        .value('mp.throttleSettings', {
            enabled: true,
            time: 100
        });

})();

angular.module("digitHeiligenacht").run(["$templateCache", function($templateCache) {$templateCache.put("app/lightbox/lightbox.html","<div class=\"view-lightbox\" ng-click=\"lightbox.close()\"><figure><ui-img alt=\"{{\'WORK\' | translate}}: {{lightbox.caption | translate}}\" image=\"{{lightbox.url}}\" fixed-height=\"true\" format=\"{{lightbox.imageFormat}}\"></ui-img><figcaption ng-if=\"lightbox.caption\" class=\"text-center\" translate=\"{{lightbox.caption}}\"></figcaption></figure><ui-button custom=\"cross\" class=\"view-lightbox__close\" ng-click=\"lightbox.close()\"></ui-button></div>");
$templateCache.put("app/main/main.html","<div class=\"view-main lang-{{main.currentLanguage}}\" when-scrolled=\"{ start: \'main.scrolled = true\', end :\'main.scrolled = false\' }\"><div class=\"site-header\"><div class=\"g-row\"><div class=\"g-col-6\"><digit-brand ref=\"http://www.liebieghaus.de/\" new-window=\"true\"></digit-brand></div><div class=\"g-col-6 g-offset-6\"><div class=\"site-languages\"><ui-button ref=\"main({lang : \'de\'})\" custom=\"lang-de\" ng-show=\"main.currentLanguage == \'en\'\"></ui-button><ui-button ref=\"main({lang :\'en\'})\" custom=\"lang-en\" ng-show=\"main.currentLanguage == \'de\'\"></ui-button></div><div class=\"site-sharing\"><ui-button custom=\"share\" ng-click=\"main.showSharing = !main.showSharing\"></ui-button><div ng-show=\"main.showSharing\"><a target=\"_blank\" href=\"{{main.sharing.facebook}}\"><ui-button custom=\"facebook\"></ui-button></a> <a ng-if=\"device !== \'desktop\'\" target=\"_blank\" href=\"{{main.sharing.whatsapp}}\"><ui-button custom=\"whatsapp\"></ui-button></a> <a href=\"{{main.sharing.mail}}\"><ui-button custom=\"mail\"></ui-button></a> <a target=\"_blank\" href=\"{{main.sharing.twitter}}\"><ui-button custom=\"twitter\"></ui-button></a> <a target=\"_blank\" href=\"{{main.sharing.pinterest}}\"><ui-button custom=\"pinterest\"></ui-button></a></div></div></div></div></div><main class=\"digitorial\" broadcast-domchange=\"\"><digit-body colors=\"main.colors\"></digit-body></main><div ui-view=\"\"></div></div>");
$templateCache.put("app/components/digit-body/digit-body.html","<div class=\"digit-body\" id=\"top\"><section class=\"digitorial__intro\"><ui-parallax speed=\"0.3\"><div class=\"image\" ui-img=\"\" alt=\"{{\'WORK\' | translate}}: {{\'WORK\' | translate}}: {{\'DIGIT_TITLE_CAPTION\' | translate}}\" image=\"liebig-kampagnenmotiv.jpg\" crop=\"top\" cover=\"true\" on-load=\"main.titleImgLoaded = true\"></div></ui-parallax><div class=\"digitorial__intro-inner\"><div class=\"g-row\"><div class=\"g-col-12 g-offset-m-1 g-col-m-8\"><h1 class=\"digitorial__title\" ng-class=\"{\'show\' : main.titleImgLoaded}\"><b ng-attr-style=\"background-image: url(assets/images/heiligenacht-title_{{main.currentLanguage}}.svg)\"></b> <b ng-attr-style=\"background-image: url(assets/images/heiligenacht-subtitle_160930_{{main.currentLanguage}}.svg)\"></b> <span translate=\"{{\'DIGIT_TITLE\'}}\"></span></h1></div></div></div><ui-button custom=\"arrow-down\" class=\"digitorial__startbutton\" du-smooth-scroll=\"digit-start\"></ui-button><figcaption class=\"digitorial__titlecaption\" ng-class=\"{\'show\' : main.scrolled}\"><div class=\"g-row\"><div class=\"g-col-12\">{{\'DIGIT_TITLE_CAPTION\' | translate}}</div></div></figcaption></section><section class=\"digit-body__section-1 inverted--b before-sf-bg\" id=\"digit-start\"><div class=\"g-row g-drop-m-1\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><p class=\"intro\" translate=\"{{\'C1_INTRO\'}}\"></p></div></div><div class=\"divider divider--bright\"><span></span></div><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-6 g-offset-m-3\"><p class=\"intro intro--sans\" translate=\"{{\'C1_TEXT_1\'}}\"></p></div></div></section><section class=\"digit-body__section-1a inverted--b\"><ui-scrollfix fix-duration=\"100\" progress=\"sfprogressAltar\"><div class=\"sf-bg\"></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-6 g-align-m-center\"><figure><ui-fadeimage progress=\"sfprogressAltar\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C1_IMG_CAPTION_1\' | translate}}\" image=\"altar1.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C1_IMG_CAPTION_1\' | translate}}\" image=\"altar2_liebieghaus12.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C1_IMG_CAPTION_1\' | translate}}\" image=\"altar3_liebieghaus11.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C1_IMG_CAPTION_1\' | translate}}\" image=\"altar4_liebieghaus10.png\" format=\"png\"></ui-img></ui-fadeimage></figure></div></div><div class=\"sf-altar-figcaption\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-6 g-drop-1 g-align-m-center\"><figcaption class=\"dark\"><span class=\"star\"></span>{{\'C1_IMG_CAPTION_1\' | translate}}</figcaption></div></div></div></ui-scrollfix></section><section class=\"digit-body__section-2 before-sf-bg\"><h1 class=\"g-drop-4 g-push-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-2\"><em translate=\"{{\'C1_HEADING_1_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\" translate=\"{{\'C1_HEADING_1_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-1\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C1_TEXT_2\'}}\"></p></div></div></section><section class=\"digit-body__section-3 inverted--a before-sf-bg\"><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><p translate=\"{{\'C1_TEXT_3\'}}\"></p></div><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C1_TEXT_4\'}}\"></p></div></div><div class=\"g-row g-drop-4 g-push-4\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><ui-dropmore class=\"digit-body__dropmore-1\" ani-dir=\"right\" start-pos=\"3\" end-pos=\"21.875\" custom-button=\"plus\"><article><h3 translate=\"{{\'C1_HEADING_2\'}}\"></h3><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5\"><p translate=\"{{\'C1_TEXT_5\'}}\"></p></div><div class=\"g-col-12 g-col-m-4 g-drop-s-2\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'0496_0246r.png\', caption : \'C1_IMG_CAPTION_2\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C1_IMG_CAPTION_2\' | translate}}\" image=\"0496_0246r.png\" format=\"png\" style=\"height: 21.5625rem\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption class=\"bright\"><span class=\"star\"></span>{{\'C1_IMG_CAPTION_2\' | translate}}</figcaption></figure></div></div></article></ui-dropmore></div></div></section><ui-chapterheading img=\"\'kapitelwischer_1.png\'\" class=\"digit-body__chapter-2\"><h1><div class=\"g-row\"><div class=\"g-col-12 g-col-m-11 g-offset-m-1\"><em translate=\"{{\'C2_TITLE_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\" translate=\"{{\'C2_TITLE_2\'}}\"></div></div></h1></ui-chapterheading><section class=\"digit-body__section-4\"><div class=\"g-row g-drop-m-4\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><p class=\"intro\" translate=\"{{\'C2_TEXT_1\'}}\"></p></div></div><figure><div class=\"g-row g-drop-m-4 g-drop-2\"><a class=\"zoom clearfix\" ui-sref=\"main.lightbox({ url : \'abb-3-2_bilddatei-freiburg-teppich-A1708_revised.png\', caption : \'C2_IMG_CAPTION_A1\', imageFormat: \'png\'})\"><div class=\"g-col-12 g-col-m-4 g-offset-m-2\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C2_IMG_CAPTION_A2\' | translate}}\" image=\"abb_3__2_bilddatei_freiburg_teppich_a1708_auschnitt-1.jpg\"></ui-img></div><div class=\"g-col-12 g-col-m-4 g-drop-s-2\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C2_IMG_CAPTION_A2\' | translate}}\" image=\"abb_3__2_bilddatei_freiburg_teppich_a1708_auschnitt-2.jpg\"></ui-img></div><ui-button custom=\"magnifier\"></ui-button></a></div><div class=\"g-row g-push-2 g-drop-s-1\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><figcaption><span class=\"star\"></span>{{\'C2_IMG_CAPTION_A2\' | translate}}</figcaption></div></div></figure><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4 g-offset-m-2\"><p translate=\"{{\'C2_TEXT_2\'}}\"></p></div><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C2_TEXT_3\'}}\"></p></div></div><div class=\"blockquote__container\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><blockquote><p translate=\"{{\'C2_QUOTE_1\'}}\"></p><cite translate=\"{{\'C2_CITE_1\'}}\"></cite></blockquote></div></div></div></section><section class=\"digit-body__section-5\"><h1 class=\"g-drop-3\"><div class=\"g-row\"><div class=\"g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C2_HEADING_1_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-m-8 g-offset-m-4\" translate=\"{{\'C2_HEADING_1_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-10\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C2_TEXT_4\'}}\"></p></div></div></section><section class=\"digit-body__section-6 inverted--a\"><div class=\"g-row g-drop-1 g-pull-6 animate-subtle_move from-bottom\" when-in-viewport=\"joseph.inviewport = true\" wiv-at=\"bottom\" ng-class=\"{\'in-viewport\' : joseph.inviewport}\"><div class=\"g-col-12 g-col-m-6 g-offset-m-2\"><figure class=\"g-push-1\"><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_4_feinkonzept3c_josefs_traum_farbig.png\', caption : \'C2_IMG_CAPTION_A3\',imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C2_IMG_CAPTION_A3\' | translate}}\" image=\"abb_4_feinkonzept3c_josefs_traum_farbig.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span>{{\'C2_IMG_CAPTION_A3\' | translate}}</figcaption></figure></div></div><div class=\"g-row g-drop-1 g-push-1\"><span class=\"g-col-12 g-col-m-9 g-offset-m-3 border border--right\"></span><div class=\"g-col-12 g-col-m-4 g-offset-m-3\"><p translate=\"{{\'C2_TEXT_5\'}}\"></p></div><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C2_TEXT_6\'}}\"></p></div></div></section><section class=\"digit-body__section-7\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C2_HEADING_2_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-m-8 g-offset-m-4\"><span translate=\"{{\'C2_HEADING_2_2\'}}\"></span></div></div></h1><div class=\"divider\"><span></span>></div><div class=\"g-row g-drop-1 g-push-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C2_TEXT_7\'}}\"></p></div></div></section><section class=\"digit-body__section-8 inverted--a\"><div class=\"g-row hide-medium-up\"><div class=\"g-col-12 g-push-3\"><p translate=\"{{\'C2_TEXT_7\'}}\"></p></div></div><ui-scrollfix fix-duration=\"100\" progress=\"sfMariaProgress\"><div class=\"g-row g-drop-m-3\"><div class=\"g-col-12 g-col-m-6 g-offset-m-1 hide-small\"><div class=\"g-row g-drop-4\"><div class=\"g-col-12 g-col-m-5\"><p translate=\"{{\'C2_TEXT_8\'}}\"></p><p translate=\"{{\'C2_TEXT_8a\'}}\"></p></div></div></div><div class=\"g-col-12 g-col-m-4\"><figure><div class=\"g-row\"><div class=\"g-col-8 g-offset-2 g-col-m-3\"><ui-magnifier progress=\"sfMariaProgress\" options=\"digit.magnifierMariaOptions\"></ui-magnifier></div></div><figcaption><span class=\"star\"></span><span translate=\"{{\'C2_IMG_CAPTION_1\'}}\"></span></figcaption></figure></div></div></ui-scrollfix><div class=\"g-row g-drop-3\"><div class=\"g-col-12 g-offset-m-1 g-col-m-8\"><ui-dropmore class=\"digit-body__dropmore-2\" ani-dir=\"left\" start-pos=\"0\" end-pos=\"19.375\" custom-button=\"plus\"><article><h3 translate=\"{{\'C2_HEADING_3\'}}\"></h3><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5\"><p translate=\"{{\'C2_TEXT_9\'}}\"></p><figcaption><span class=\"star\"></span><span translate=\"{{\'C2_IMG_CAPTION_2\'}}\"></span></figcaption></div><div class=\"g-col-12 g-col-m-3\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_6_herbergssuche.png\', caption : \'C2_IMG_CAPTION_2\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C2_IMG_CAPTION_2\' | translate}}\" image=\"abb_6_herbergssuche.png\" format=\"png\" style=\"height: 18.75rem\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a></figure></div></div></article><div class=\"g-drop-2\"></div></ui-dropmore></div></div></section><ui-chapterheading img=\"\'kapitelwischer_rba_c002341b.jpg\'\" class=\"digit-body__chapter-3\"><h1><div class=\"g-row\"><div class=\"g-col-12 g-col-m-11 g-offset-m-1\"><em translate=\"{{\'C3_TITLE_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-2\" translate=\"{{\'C3_TITLE_2\'}}\"></div></div></h1></ui-chapterheading><section class=\"digit-body__section-9\"><div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><p class=\"intro\" translate=\"{{\'C3_TEXT_1\'}}\"></p></div></div></section><section class=\"digit-body__section-10 inverted--a\"><ui-scrollfix fix-duration=\"100\" progress=\"sfKoelnProgress\"><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-5\"><figure><ui-magnifier progress=\"sfKoelnProgress\" options=\"digit.magnifierKoelnOptions\"></ui-magnifier><figcaption><span class=\"star\"></span>{{\'C3_IMG_CAPTION_1\' | translate}}</figcaption></figure></div><div class=\"g-col-12 g-col-m-6 g-offset-m-1 g-drop-s-2 g-drop-m-6\"><div class=\"g-row\"><span class=\"border border--right\"></span></div><p translate=\"{{\'C3_TEXT_2\'}}\"></p><p translate=\"{{\'C3_TEXT_2a\'}}\"></p></div></div></ui-scrollfix><div class=\"g-row g-drop-2 g-drop-s-5\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><ui-dropmore class=\"digit-body__dropmore-3\" ani-dir=\"right\" start-pos=\"12\" end-pos=\"21.775\" custom-button=\"plus\"><article><h3 translate=\"{{\'C3_HEADING_1\'}}\"></h3><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4 g-push-s-3\"><p translate=\"{{\'C3_TEXT_3\'}}\"></p></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><p translate=\"{{\'C3_TEXT_3a\'}}\"></p></div></div></article><div class=\"g-drop-2\"></div></ui-dropmore></div></div></section><section class=\"digit-body__section-11 before-sf-bg\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C3_HEADING_2_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\" translate=\"{{\'C3_HEADING_2_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C3_TEXT_4\'}}\"></p></div></div></section><section class=\"digit-body__section-12 inverted--a\"><ui-scrollfix fix-duration=\"100\" progress=\"sf1progress\"><div class=\"sf-bg\"></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-align-m-center\"><figure><ui-zoomimage options=\"digit.zoomImg1\" progress=\"sf1progress\"></ui-zoomimage><div class=\"g-row\"><div class=\"g-col-12 g-col-m-6 g-offset-m-4\"><figcaption><span class=\"star\"></span>{{\'C3_IMG_CAPTION_2\' | translate}}</figcaption></div></div></figure></div></div></ui-scrollfix><div class=\"g-row g-drop-2 g-push-3\"><span class=\"g-col-12 g-col-m-9 g-offset-m-3 border border--right\"></span><div class=\"g-col-12 g-col-m-6 g-offset-m-3\"><p translate=\"{{\'C3_TEXT_5\'}}\"></p></div></div><ui-audioplayer ng-if=\"main.currentLanguage === \'de\'\" audio=\"assets/audio/1_de.mp3\" audiotitle=\"Die Vision der Heiligen Birgitta<br />aus Birgittas Himmlischen Offenbarungen\" custom-play-button=\"play\" custom-pause-button=\"pause\"></ui-audioplayer><ui-audioplayer ng-if=\"main.currentLanguage === \'en\'\" audio=\"assets/audio/1_en.mp3\" audiotitle=\"The Vision of the Nativity<br />from Saint Bridget’s Prophecies and Revelations\" custom-play-button=\"play\" custom-pause-button=\"pause\"></ui-audioplayer><div class=\"g-row g-drop-4\"><span class=\"g-col-12 g-col-m-9 g-offset-m-3\"></span><div class=\"g-col-12 g-col-m-6 g-offset-m-3\"><p translate=\"{{\'C3_TEXT_5a\'}}\"></p></div></div><div class=\"g-row g-drop-5\"><div class=\"g-col-12 g-col-m-9 g-offset-m-2\"><ui-dropmore class=\"digit-body__dropmore-4\" ani-dir=\"right\" start-pos=\"-5\" end-pos=\"21.775\" custom-button=\"plus\"><article><h3 translate=\"{{\'C3_HEADING_3\'}}\"></h3><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C3_TEXT_6\'}}\"></p></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1 g-drop-s-3\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'ausschnitt_abb_8_4b_bilddatei_rom_vatikanische_museen_inv_40137_klein_geburt_ausschnitt.jpg\'})\"><ui-img image=\"ausschnitt_abb_8_4b_bilddatei_rom_vatikanische_museen_inv_40137_klein_geburt_ausschnitt.jpg\" style=\"height: 24.25rem\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a></figure></div></div></article><div class=\"g-drop-2\"></div></ui-dropmore></div></div></section><section class=\"digit-body__section-13\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C3_HEADING_4_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\" translate=\"{{\'C3_HEADING_4_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-m-7\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C3_TEXT_7\'}}\"></p></div></div></section><section class=\"digit-body__section-14 inverted--a\"><div class=\"g-row g-pull-m-4\"><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><div class=\"g-drop-m-12\"></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-push-1\"><p translate=\"{{\'C3_TEXT_8\'}}\"></p><p translate=\"{{\'C3_TEXT_8a\'}}\"></p></div><span class=\"g-col-12 g-col-m-5 border border--left\"></span></div></div><div class=\"g-col-12 g-col-m-4 g-offset-m-2 animate-subtle_move from-bottom\" when-in-viewport=\"anbetung.inviewport = true\" wiv-at=\"bottom\" ng-class=\"{\'in-viewport\' : anbetung.inviewport}\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_9_anbetung_der_hirten_staedel.png\', caption : \'C3_IMG_CAPTION_3\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C3_IMG_CAPTION_3\' | translate}}\" image=\"abb_9_anbetung_der_hirten_staedel.png\" format=\"png\"></ui-img><figcaption><span class=\"star\"></span><span translate=\"{{\'C3_IMG_CAPTION_3\'}}\"></span></figcaption><ui-button custom=\"magnifier\"></ui-button></a></figure></div></div><div class=\"g-row g-drop-2 g-push-m-8\"><div class=\"animated-cols\" when-in-viewport=\"cols1.inviewport = true\" wiv-at=\"bottom\" wiv-buffer=\"100\" ng-class=\"{\'in-viewport\' : cols1.inviewport}\"><div class=\"g-col-12 g-push-s-4 g-col-m-4\"><ui-metaimage image=\"abb_9_anbetung_der_hirten_staedel_ausschnitt-1.jpg\" group=\"meta-anbetung\" custom-button=\"plus\"><h4 translate=\"{{\'C3_HEADING_7\'}}\"></h4><p translate=\"{{\'C3_TEXT_11\'}}\"></p></ui-metaimage></div><div class=\"g-col-12 g-push-s-4 g-col-m-4\"><ui-metaimage image=\"abb_9_anbetung_der_hirten_staedel_ausschnitt-2.jpg\" group=\"meta-anbetung\" custom-button=\"plus\"><h4 translate=\"{{\'C3_HEADING_5\'}}\"></h4><p translate=\"{{\'C3_TEXT_9\'}}\"></p></ui-metaimage></div><div class=\"g-col-12 g-push-s-4 g-col-m-4\"><ui-metaimage image=\"abb_9_anbetung_der_hirten_staedel_ausschnitt-3.jpg\" group=\"meta-anbetung\" custom-button=\"plus\"><h4 translate=\"{{\'C3_HEADING_6\'}}\"></h4><p translate=\"{{\'C3_TEXT_10\'}}\"></p></ui-metaimage></div></div></div></section><ui-chapterheading img=\"\'kapitelwischer_3.jpg\'\" class=\"digit-body__chapter-4\"><h1><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-2\"><em translate=\"{{\'C4_TITLE_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\" translate=\"{{\'C4_TITLE_2\'}}\"></div></div></h1></ui-chapterheading><section class=\"digit-body__section-15\"><div class=\"g-row g-drop-1 g-push-10\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><p class=\"intro\" translate=\"{{\'C4_TEXT_1\'}}\"></p></div></div></section><section class=\"digit-body__section-16 inverted--a\"><div class=\"g-row g-drop-4\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2 g-pull-7\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'karlsruhe_blm_maria_im_wochenbett_revised.png\', caption : \'C4_IMG_CAPTION_1\', imageFormat : \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_1\' | translate}}\" image=\"karlsruhe_blm_maria_im_wochenbett_revised.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption class=\"text-center\"><span class=\"star\"></span>{{\'C4_IMG_CAPTION_1\' | translate}}</figcaption></figure></div></div><div class=\"g-row\"><span class=\"g-col-12 g-offset-m-1 g-col-m-8 border border--right\"></span></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><p translate=\"{{\'C4_TEXT_2\'}}\"></p></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><p translate=\"{{\'C4_TEXT_2a\'}}\"></p></div></div></section><section class=\"digit-body__section-17\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C4_HEADING_1_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-7 g-offset-m-5\" translate=\"{{\'C4_HEADING_1_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-1\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C4_TEXT_3\'}}\"></p></div></div></section><section class=\"digit-body__section-18 inverted--a\"><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-5\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_11_6_chartreuse_adoration_des_mages_mond_170_mb_a_foto_m_bertola.png\', imageFormat: \'png\', caption: \'C4_IMG_CAPTION_2\' })\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_2\' | translate}}\" image=\"abb_11_6_chartreuse_adoration_des_mages_mond_170_mb_a_foto_m_bertola.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span>{{\'C4_IMG_CAPTION_2\' | translate}}</figcaption></figure></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1 g-drop-m-8\"><div class=\"g-row\"><span class=\"g-col-12 g-col-m-4 border border--right\"></span><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C4_TEXT_4\'}}\"></p></div></div></div></div><div class=\"g-row\"><div class=\"g-col-12 g-drop-m-1 g-drop-s-4 g-col-m-9 g-offset-m-2\"><ui-dropmore class=\"digit-body__dropmore-5\" ani-dir=\"right\" start-pos=\"8\" end-pos=\"21.775\" custom-button=\"plus\"><article><h3 translate=\"{{\'C4_HEADING_2\'}}\"></h3><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C4_TEXT_5\'}}\"></p></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><p translate=\"{{\'C4_TEXT_6\'}}\"></p></div></div></article><div class=\"g-drop-2\"></div></ui-dropmore></div></div></section><section class=\"digit-body__section-19 before-sf-bg\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\"><em translate=\"{{\'C4_HEADING_3_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-7 g-offset-m-5\" translate=\"{{\'C4_HEADING_3_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-2\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C4_TEXT_7\'}}\"></p></div></div></section><section class=\"digit-body__section-20 inverted--a\"><ui-scrollfix fix-duration=\"100\" progress=\"sf2progress\"><div class=\"g-row g-drop-3 g-drop-m-5\"><div class=\"g-col-12 g-col-m-7\"><figure><ui-zoomimage options=\"digit.zoomImg2\" progress=\"sf2progress\"></ui-zoomimage><figcaption class=\"text-center\"><span class=\"star\"></span>{{\'C4_IMG_CAPTION_3\' | translate}}</figcaption></figure></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1 hide-small\"><p translate=\"{{\'C4_TEXT_8\'}}\"></p><p translate=\"{{\'C4_TEXT_8a\'}}\"></p></div></div></ui-scrollfix><div class=\"g-row hide-medium-up\"><div class=\"g-col-12\"><p translate=\"{{\'C4_TEXT_8\'}}\"></p><p translate=\"{{\'C4_TEXT_8a\'}}\"></p></div></div></section><section class=\"digit-body__section-21\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C4_HEADING_4_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\" translate=\"{{\'C4_HEADING_4_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-m-8\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C4_TEXT_9\'}}\"></p></div></div></section><section class=\"digit-body__section-22 inverted--a\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-drop-m-8 g-push-1\"><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C4_TEXT_10\'}}\"></p><p translate=\"{{\'C4_TEXT_10a\'}}\"></p></div></div><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-pull-m-4 animate-subtle_move from-bottom\" when-in-viewport=\"evangelistar.inviewport = true\" wiv-at=\"bottom\" ng-class=\"{\'in-viewport\' : evangelistar.inviewport}\"><figure class=\"g-pullnext-m-3 g-push-s-3\"><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_13_7_bilddatei_muenster_darbringung_jesu_im_tempel_1183lm.png\', caption : \'C4_IMG_CAPTION_4\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_4\' | translate}}\" image=\"abb_13_7_bilddatei_muenster_darbringung_jesu_im_tempel_1183lm.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span>{{\'C4_IMG_CAPTION_4\' | translate}}</figcaption></figure></div></div><ui-scrollfix-nonclone fix-duration=\"100\" progress=\"sfStatueProgress\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-drop-m-10 hide-small\"><ui-dropmore class=\"digit-body__dropmore-6\" ani-dir=\"left\" start-pos=\"0\" end-pos=\"11.875\" custom-button=\"plus\"><article><h3 translate=\"{{\'C4_HEADING_5\'}}\"></h3><p translate=\"{{\'C4_TEXT_11\'}}\"></p></article></ui-dropmore></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><figure><ui-fadeimage progress=\"sfStatueProgress\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_6\' | translate}}\" image=\"knabe1_sr_10_kat_68.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_6\' | translate}}\" image=\"knabe2_inv-nr_1048c.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_6\' | translate}}\" image=\"knabe3_inv-nr_1048b.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_6\' | translate}}\" image=\"knabe4_inv-nr_1048.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_6\' | translate}}\" image=\"knabe1_sr_10_kat_68.png\" format=\"png\"></ui-img></ui-fadeimage><figcaption><span class=\"star\"></span>{{\'C4_IMG_CAPTION_6\' | translate}}</figcaption></figure></div></div></ui-scrollfix-nonclone><div class=\"g-row hide-medium-up\"><div class=\"g-col-12 g-drop-3\"><ui-dropmore class=\"digit-body__dropmore-6\" ani-dir=\"right\" start-pos=\"-5\" end-pos=\"11.875\" custom-button=\"plus\"><article><h3 translate=\"{{\'C4_HEADING_5\'}}\"></h3><p translate=\"{{\'C4_TEXT_11\'}}\"></p></article></ui-dropmore></div></div></section><section class=\"digit-body__section-23\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C4_HEADING_5_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\" translate=\"{{\'C4_HEADING_5_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-3\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C4_TEXT_12\'}}\"></p></div></div></section><section class=\"digit-body__section-24 inverted--a\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-drop-1 g-push-1\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_14_8_karlsruhe_abreise_der_koenige_bruchsal_1_13r.png\', caption : \'C4_IMG_CAPTION_5\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C4_IMG_CAPTION_5\' | translate}}\" image=\"abb_14_8_karlsruhe_abreise_der_koenige_bruchsal_1_13r.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span>{{\'C4_IMG_CAPTION_5\' | translate}}</figcaption></figure></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1 g-drop-m-12 g-push-m-2\"><div class=\"g-row\"><span class=\"g-col-12 g-col-m-4 border border--right\"></span></div><p translate=\"{{\'C4_TEXT_13\'}}\"></p><p translate=\"{{\'C4_TEXT_13a\'}}\"></p></div></div></section><ui-chapterheading img=\"\'kapitelwischer_4.jpg\'\" class=\"digit-body__chapter-5\"><h1><div class=\"g-row\"><div class=\"g-col-12 g-col-m-11 g-offset-m-1\"><em translate=\"{{\'C5_TITLE_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-2\">{{\'C5_TITLE_2\' | translate}}</div></div></h1></ui-chapterheading><section class=\"digit-body__section-25\"><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><p class=\"intro\" translate=\"{{\'C5_TEXT_1\'}}\"></p></div></div></section><section class=\"digit-body__section-26 inverted--a\"><div class=\"g-row\"><figure><div class=\"g-col-12 g-col-m-3 g-offset-m-1 hide-small\"><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'dsc3868_tafel_1.png\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C5_IMG_CAPTION_1\' | translate}}\" image=\"dsc3868_tafel_1.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption class=\"g-drop-m-5\"><span class=\"star\"></span>{{\'C5_IMG_CAPTION_1\' | translate}}</figcaption></div><div class=\"g-col-12 g-col-m-4 g-drop-m-6\"><p translate=\"{{\'C5_TEXT_2\'}}\"></p><p translate=\"{{\'C5_TEXT_2a\'}}\"></p><div class=\"g-col-12 hide-medium-up\"><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'dsc3868_tafel.png\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C5_IMG_CAPTION_1\' | translate}}\" image=\"dsc3868_tafel.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption class=\"g-drop-m-5\"><span class=\"star\"></span>{{\'C5_IMG_CAPTION_1\' | translate}}</figcaption></div></div><div class=\"g-col-12 g-col-m-3 hide-small\"><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'dsc3868_tafel_2.png\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}:\" image=\"dsc3868_tafel_2.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a></div></figure></div><div class=\"g-row g-drop-s-4\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4 g-pull-m-1\"><ui-dropmore class=\"digit-body__dropmore-befehl\" ani-dir=\"right\" start-pos=\"-10\" end-pos=\"19.275\" custom-button=\"plus\"><article><h3 translate=\"{{\'C5_HEADING_META_1\'}}\"></h3><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C5_TEXT_META_1_1\'}}\"></p></div><div class=\"g-col-12 g-col-m-4\"><p translate=\"{{\'C5_TEXT_META_1_2\'}}\"></p></div></div></article></ui-dropmore></div></div></section><section class=\"digit-body__section-27\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C5_HEADING_1_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\" translate=\"{{\'C5_HEADING_1_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C5_TEXT_3\'}}\"></p></div></div></section><section class=\"digit-body__section-28\"><ui-audioplayer ng-if=\"main.currentLanguage === \'de\'\" audio=\"assets/audio/2_de.mp3\" audiotitle=\"Das Palmwunder<br />aus dem Pseudo-Matthäusevangelium\" custom-play-button=\"play\" custom-pause-button=\"pause\"></ui-audioplayer><ui-audioplayer ng-if=\"main.currentLanguage === \'en\'\" audio=\"assets/audio/2_en.mp3\" audiotitle=\"The Miracle of the Palm Tree<br />from the Gospel of Pseudo-Matthew\" custom-play-button=\"play\" custom-pause-button=\"pause\"></ui-audioplayer></section><section class=\"digit-body__section-29 inverted--a\"><div class=\"g-row g-drop-2\"><div class=\"g-col-12 g-col-m-4 g-offset-m-2\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_16a_10_schongauer_35709_flucht_nach_aegypten_40774.png\', caption : \'C5_IMG_CAPTION_A1\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C5_IMG_CAPTION_A1\' | translate}}\" image=\"abb_16a_10_schongauer_35709_flucht_nach_aegypten_40774.png\" style=\"height: 29.4375rem; padding-top: 1.75rem\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span><span translate=\"{{\'C5_IMG_CAPTION_A1\'}}\"></span></figcaption></figure></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'bilddatei_wien_gross_kk_46_201604_stitch.png\', caption: \'C5_IMG_CAPTION_A2\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C5_IMG_CAPTION_A2\' | translate}}\" image=\"bilddatei_wien_gross_kk_46_201604_stitch.png\" format=\"png\" style=\"height: 29.4375rem\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span>{{\'C5_IMG_CAPTION_A2\' | translate}}</figcaption></figure></div></div><div class=\"g-row g-push-2\"><span class=\"g-col-12 g-col-m-10 g-offset-m-2 border border--right\"></span><div class=\"g-col-12 g-col-m-4 g-offset-m-2\"><p translate=\"{{\'C5_TEXT_4\'}}\"></p></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><p translate=\"{{\'C5_TEXT_5\'}}\"></p></div></div></section><section class=\"digit-body__section-30\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C5_HEADING_2_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\" translate=\"{{\'C5_HEADING_2_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1 g-push-8\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C5_TEXT_6\'}}\"></p></div></div></section><section class=\"digit-body__section-31 inverted--a\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-pull-4 animate-subtle_move from-bottom\" when-in-viewport=\"duerer.inviewport = true\" wiv-at=\"bottom\" ng-class=\"{\'in-viewport\' : duerer.inviewport}\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_17_r_6l_kat_87.png\', caption : \'C5_IMG_CAPTION_2\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C5_IMG_CAPTION_2\' | translate}}\" image=\"abb_17_r_6l_kat_87.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span>{{\'C5_IMG_CAPTION_2\' | translate}}</figcaption></figure></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1 g-drop-m-6\"><p translate=\"{{\'C5_TEXT_7\'}}\"></p></div></div><div class=\"blockquote__container\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-10 g-offset-m-1\"><blockquote><p translate=\"{{\'C5_QUOTE_1\'}}\"></p><cite translate=\"{{\'C5_CITE_1\'}}\"></cite></blockquote></div></div></div></section><section class=\"digit-body__section-32\"><h1 class=\"g-drop-1\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-9 g-offset-m-3\"><em translate=\"{{\'C5_HEADING_3_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-8 g-offset-m-4\" translate=\"{{\'C5_HEADING_3_2\'}}\"></div></div></h1><div class=\"divider\"><span></span></div><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C5_TEXT_8\'}}\"></p></div></div></section><section class=\"digit-body__section-33 inverted--a\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-4 g-offset-m-1\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_18_heimkehr_aus_aegypten.png\', caption : \'C5_IMG_CAPTION_3\', imageFormat: \'png\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C5_IMG_CAPTION_3\' | translate}}\" image=\"abb_18_heimkehr_aus_aegypten.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption><span class=\"star\"></span>{{\'C5_IMG_CAPTION_3\' | translate}}</figcaption></figure></div><div class=\"g-col-12 g-col-m-4 g-offset-m-2 g-drop-m-12\"><div class=\"g-row\"><span class=\"g-col-12 g-col-m-4 border border--right\"></span></div><p translate=\"{{\'C5_TEXT_9\'}}\"></p></div></div></section><section class=\"digit-body__section-34 inverted--b\"><h1><div class=\"g-row\"><div class=\"g-col-12 g-col-m-6 g-offset-m-2\"><em translate=\"{{\'C6_HEADING_1_1\'}}\"></em></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-6 g-offset-m-4\" translate=\"{{\'C6_HEADING_1_2\'}}\"></div></div></h1><div class=\"divider divider--bright\"><span></span></div><div class=\"g-row g-drop-1\"><div class=\"g-col-12 g-col-m-8 g-offset-m-2\"><p class=\"intro intro--small\" translate=\"{{\'C6_TEXT_1\'}}\"></p></div></div><div class=\"g-row\"><div class=\"g-col-12 g-col-m-5 g-drop-1\"><figure><a class=\"zoom\" ui-sref=\"main.lightbox({ url : \'abb_20_12a_koeln_christkindwiege.png\', imageFormat: \'png\', caption: \'C6_IMG_CAPTION_1\'})\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C6_IMG_CAPTION_1\' | translate}}\" image=\"abb_20_12a_koeln_christkindwiege.png\" format=\"png\"></ui-img><ui-button custom=\"magnifier\"></ui-button></a><figcaption class=\"bright\"><span class=\"star\"></span>{{\'C6_IMG_CAPTION_1\' | translate}}</figcaption></figure></div><div class=\"g-col-12 g-col-m-5 g-offset-m-1 g-drop-m-6 g-push-s-3\"><p translate=\"{{\'C6_TEXT_2\'}}\"></p><div class=\"digit__audioplayer-tiny g-push-2 g-push-m-4\"><ui-audioplayer audio=\"assets/audio/kirchchor_final.mp3\" audiotitle=\"{{\'C6_AUDIO_TITLE_1\' | translate}}\" custom-play-button=\"note\" custom-pause-button=\"pause\"></ui-audioplayer></div></div></div><ui-scrollfix fix-duration=\"100\" progress=\"sfprogressGeheim\"><div class=\"g-row g-drop-m-2\"><div class=\"g-col-12 g-col-m-4 g-offset-m-2 g-drop-m-11 g-drop-s-3\"><p translate=\"{{\'C6_TEXT_3\'}}\"></p></div><div class=\"g-col-12 g-col-m-4 g-offset-m-1 g-drop-1\"><figure><ui-fadeimage progress=\"sfprogressGeheim\"><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C6_IMG_CAPTION_2\' | translate}}\" image=\"img_7870.png\" format=\"png\"></ui-img><ui-img alt=\"{{\'WORK\' | translate}}: {{\'C6_IMG_CAPTION_2\' | translate}}\" image=\"img_7866.png\" format=\"png\"></ui-img></ui-fadeimage><figcaption class=\"bright\"><span class=\"star\"></span>{{\'C6_IMG_CAPTION_2\' | translate}}</figcaption></figure></div></div></ui-scrollfix></section></div><digit-footer show-copyrights=\"main.showCopyrights\"></digit-footer>");
$templateCache.put("app/components/digit-brand/digit-brand.html","<h1 class=\"digit-brand\"><a href=\"{{brand.ref}}\" ng-attr-target=\"{{brand.newWindow ? \'_blank\' : \'\'}}\"><div class=\"digit-brand__logo\"><svg width=\"219\" height=\"64\" viewbox=\"0 0 219 64\" xmlns=\"http://www.w3.org/2000/svg\"><title>Liebieghaus</title><path d=\"M199.44 45.712v-5.41c0-1.56-.03-1.787-.915-1.892l-.242-.03c-.09-.06-.06-.33.03-.376.647.03 1.158.046 1.776.046h2.827c.964 0 1.85 0 2.032-.046.09.256.18 1.337.24 2-.06.09-.3.12-.376.03-.226-.707-.362-1.233-1.145-1.428-.316-.076-.797-.09-1.46-.09h-1.082c-.453 0-.453.03-.453.6v3.005c0 .42.045.42.496.42h.874c.632 0 1.1-.028 1.28-.088.18-.06.285-.15.36-.526l.122-.617c.075-.09.33-.09.39.015 0 .36-.06.947-.06 1.517 0 .54.06 1.112.06 1.442-.06.105-.315.105-.39.015l-.137-.586c-.06-.27-.166-.496-.467-.57-.21-.06-.572-.077-1.16-.077h-.872c-.45 0-.495.016-.495.406v2.118c0 .798.045 1.308.286 1.564.18.18.498.345 1.822.345 1.16 0 1.595-.06 1.926-.226.27-.15.677-.676 1.068-1.457.106-.076.316-.03.378.105-.106.526-.483 1.682-.678 2.088a182.59 182.59 0 0 0-4.033-.045h-1.354c-.65 0-1.16.015-2.048.045-.09-.045-.12-.285-.03-.382l.496-.045c.858-.075.933-.3.933-1.87m-10.076-6.763v3.516c0 .27 0 .437.044.496.045.045.27.076 1.038.076.542 0 1.114-.06 1.55-.392.407-.315.753-.84.753-1.862 0-1.187-.74-2.314-2.41-2.314-.932 0-.976.06-.976.48m-1.235 6.757v-5.39c0-1.426-.046-1.682-.664-1.757l-.48-.06c-.106-.075-.106-.315.014-.375.842-.075 1.88-.12 3.356-.12.934 0 1.82.075 2.512.45.723.376 1.25 1.052 1.25 2.103 0 1.428-1.13 2.21-1.88 2.51-.077.09 0 .24.074.36 1.204 1.938 2.002 3.14 3.024 3.996.256.226.633.39 1.04.42.074.03.09.15.015.21-.135.046-.376.076-.662.076-1.28 0-2.046-.375-3.115-1.898-.39-.554-1.008-1.59-1.475-2.264-.225-.33-.467-.48-1.068-.48-.677 0-.706.015-.706.33v1.89c0 1.575.03 1.755.902 1.875l.316.045c.09.076.06.336-.03.38a38.008 38.008 0 0 0-3.672 0c-.09-.044-.12-.273-.03-.38l.377-.045c.872-.105.902-.3.902-1.876m-4.972-2.16v-1.726c0-.93-.03-2.66-.286-3.11-.106-.18-.376-.285-.753-.314l-.376-.03c-.09-.106-.062-.3.03-.362.572.03 1.128.046 1.716.046.63 0 1.038-.016 1.578-.046.12.076.106.27.03.36l-.36.032c-.376.03-.663.164-.752.36-.21.495-.21 2.223-.21 3.065v1.698c0 1.307-.21 2.69-1.054 3.59-.648.707-1.76 1.097-2.876 1.097-1.037 0-2.076-.195-2.812-.826-.798-.662-1.174-1.76-1.174-3.547v-3.545c0-1.562-.03-1.818-.904-1.892l-.375-.03c-.09-.06-.06-.316.03-.362.754.03 1.264.046 1.866.046.617 0 1.114-.016 1.852-.046.09.046.12.3.03.36l-.36.032c-.874.074-.905.33-.905 1.892v3.245c0 2.418.752 4.012 3.054 4.012 2.183 0 3.01-1.713 3.01-3.997m-14.42-4.522v6.68c0 1.577.03 1.8.902 1.877l.48.045c.09.06.06.336-.03.38-.856-.03-1.37-.042-1.97-.042-.602 0-1.13.013-2.092.043-.09-.046-.12-.306 0-.382l.542-.045c.857-.076.933-.3.933-1.877v-6.71c0-.466 0-.48-.452-.48h-.827c-.647 0-1.473.03-1.85.375-.36.33-.51.66-.678 1.036-.12.09-.33.016-.39-.105.24-.674.466-1.635.57-2.236.047-.03.242-.045.286 0 .093.48.59.466 1.28.466h6.095c.813 0 .95-.03 1.174-.42.074-.03.24-.016.27.044-.166.616-.27 1.832-.226 2.282-.06.12-.315.12-.39.03-.047-.375-.152-.93-.378-1.095-.345-.255-.917-.375-1.745-.375h-1.067c-.452 0-.436.015-.436.51m-11.562-.014v6.698c0 1.575.03 1.77.992 1.875l.407.045c.09.076.06.336-.03.38a52.208 52.208 0 0 0-1.956-.042c-.633 0-1.173.013-1.836.043-.09-.046-.12-.29-.03-.382l.315-.045c.874-.12.904-.3.904-1.875v-5.54c0-1.277-.03-1.533-.707-1.608l-.54-.06c-.106-.09-.092-.315.028-.375.8-.105 1.732-.12 2.98-.12 1.25 0 2.183.165 2.89.6.693.436 1.204 1.217 1.204 2.254 0 1.38-.857 2.072-1.504 2.388-.663.315-1.46.45-2.077.45-.106-.045-.106-.27-.016-.3 1.627-.3 2.213-1.217 2.213-2.524 0-1.457-.86-2.404-2.423-2.404-.797 0-.812.06-.812.54m-10.588 6.702v-5.41c0-1.576-.03-1.817-.978-1.892l-.378-.03c-.09-.06-.06-.33.03-.376.843.03 1.354.046 1.957.046.585 0 1.097-.016 1.85-.046.09.046.12.316.03.376l-.36.03c-.89.075-.92.316-.92 1.893v5.228c0 .947.045 1.338.317 1.624.164.165.45.345 1.64.345 1.28 0 1.594-.06 1.835-.196.302-.18.693-.722.993-1.487.092-.076.377-.015.377.09 0 .165-.42 1.697-.632 2.103-.768-.03-2.197-.045-3.747-.045h-1.384c-.633 0-1.115.015-1.958.045-.09-.045-.12-.285-.03-.382l.45-.045c.874-.09.905-.3.905-1.87m-5.403-2.165V41.82c0-.93-.03-2.66-.286-3.11-.104-.18-.376-.285-.752-.314l-.375-.03c-.09-.106-.06-.3.03-.362.573.03 1.128.046 1.716.046.632 0 1.037-.016 1.58-.046.12.076.104.27.03.36l-.36.032c-.378.03-.664.164-.753.36-.21.495-.21 2.223-.21 3.065v1.698c0 1.307-.212 2.69-1.056 3.59-.646.707-1.76 1.097-2.872 1.097-1.04 0-2.078-.195-2.815-.826-.798-.662-1.174-1.76-1.174-3.547v-3.545c0-1.562-.03-1.818-.903-1.892l-.375-.03c-.092-.06-.06-.316.03-.362.752.03 1.263.046 1.865.046.616 0 1.113-.016 1.85-.046.09.046.12.3.03.36l-.36.032c-.873.074-.904.33-.904 1.892v3.245c0 2.418.752 4.012 3.054 4.012 2.183 0 3.01-1.713 3.01-3.997m-18.538 2.16v-5.405c0-1.577-.03-1.818-.903-1.893l-.377-.03c-.09-.06-.06-.33.03-.376a35.87 35.87 0 0 0 3.642 0c.09.046.12.316.03.376l-.286.03c-.872.09-.902.316-.902 1.893v1.728c0 .286.03.572.195.572.136 0 .316-.09.42-.166.212-.18.603-.57.77-.72l1.623-1.61c.287-.268 1.024-1.034 1.174-1.245.076-.104.106-.18.106-.24s-.06-.105-.256-.15l-.406-.09c-.105-.106-.09-.3.03-.376.526.03 1.128.046 1.655.046.53 0 1.04-.016 1.492-.046.105.076.12.286.03.376-.392.03-.98.18-1.4.42-.422.24-1.264.947-2.107 1.744l-1.354 1.277c-.21.21-.346.346-.346.466 0 .105.09.226.286.466 1.43 1.635 2.59 2.985 3.762 4.215.36.36.692.555 1.205.616l.405.045c.106.076.076.336-.03.38-.39-.03-.978-.042-1.685-.042-.617 0-1.144.013-1.835.043-.106-.03-.152-.29-.06-.382l.346-.06c.21-.03.36-.075.36-.15 0-.09-.104-.21-.21-.345-.286-.36-.677-.765-1.25-1.41l-1.204-1.35c-.857-.96-1.098-1.26-1.46-1.26-.224 0-.254.195-.254.72v1.934c0 1.576.03 1.786.872 1.876l.407.045c.088.06.058.336-.03.38a42.59 42.59 0 0 0-1.838-.042c-.616 0-1.128.013-1.745.043-.09-.046-.12-.275-.03-.382l.3-.045c.8-.12.83-.3.83-1.876m-3.612-.28c0 1.65-1.25 2.778-3.206 2.778-1.266 0-2.063-.39-2.35-.555-.18-.33-.375-1.398-.404-2.103.074-.106.3-.136.36-.045.226.765.842 2.237 2.588 2.237 1.265 0 1.88-.826 1.88-1.728 0-.66-.135-1.398-1.232-2.104l-1.43-.93c-.753-.497-1.625-1.353-1.625-2.585 0-1.427 1.113-2.584 3.07-2.584.466 0 1.007.09 1.4.194.195.06.406.09.526.09.136.36.272 1.202.272 1.833-.062.09-.302.136-.378.045-.195-.72-.602-1.698-2.045-1.698-1.476 0-1.792.977-1.792 1.67 0 .87.723 1.5 1.28 1.847l1.203.75c.95.587 1.882 1.46 1.882 2.886m98.193-3.608v3.593c0 .452 0 2.24.046 2.63-.03.09-.122.165-.287.165-.18-.256-.616-.78-1.925-2.274l-3.492-3.962c-.407-.466-1.43-1.696-1.745-2.026-.092.18-.105.525-.105.976v3.272c0 .705.013 2.657.27 3.107.09.166.39.255.767.286l.466.045c.092.122.076.305-.03.38a38.322 38.322 0 0 0-1.76-.042c-.633 0-1.038.013-1.565.043-.105-.077-.12-.29-.03-.382l.407-.045c.345-.045.586-.136.66-.3.212-.54.196-2.372.196-3.093v-4.34c0-.42-.013-.734-.33-1.08-.21-.21-.57-.315-.933-.36l-.254-.03c-.092-.09-.092-.315.03-.376.632.046 1.43.046 1.7.046.24 0 .496-.016.692-.046.3.766 2.077 2.748 2.573 3.304l1.46 1.636c1.038 1.156 1.776 1.997 2.484 2.717.09-.074.09-.315.09-.63v-3.212c0-.706-.016-2.658-.3-3.107-.093-.134-.332-.225-.934-.3l-.257-.03c-.104-.09-.09-.33.03-.376.695.03 1.205.046 1.776.046.648 0 1.04-.016 1.552-.046.12.076.12.286.03.376l-.21.03c-.483.075-.784.196-.844.315-.256.54-.226 2.402-.226 3.093m-12.602 19.234v.84c0 .598.09.958.36 1.063a.122.122 0 0 1-.013.18c-.18 0-.452.06-.738.135-.797.21-1.88.39-2.694.39-1.79 0-3.43-.495-4.588-1.664-.903-.9-1.384-2.084-1.384-3.413 0-1.276.42-2.57 1.354-3.56 1.007-1.052 2.498-1.758 4.77-1.758.858 0 1.655.165 1.91.225.286.06.753.165.934.135 0 .496.09 1.278.226 2.178-.046.12-.316.136-.407.046-.42-1.624-1.55-2.135-3.084-2.135-2.918 0-4.198 2.074-4.198 4.328 0 2.888 1.49 5.152 4.515 5.152.933 0 1.49-.195 1.655-.45.075-.105.15-.374.15-.854v-.6c0-1.258-.045-1.348-.977-1.453l-.664-.076c-.118-.06-.104-.334 0-.38.438.03 1.267.043 2.154.043.586 0 1.098-.012 1.595-.043.104.06.12.29.014.38l-.24.03c-.633.076-.648.497-.648 1.262m-85.59-.17c0 1.652-1.25 2.78-3.207 2.78-1.266 0-2.063-.392-2.35-.557-.18-.33-.375-1.397-.404-2.103.074-.105.3-.136.36-.045.226.766.842 2.238 2.588 2.238 1.265 0 1.88-.826 1.88-1.728 0-.66-.135-1.397-1.232-2.103l-1.43-.93c-.753-.497-1.625-1.353-1.625-2.585 0-1.428 1.113-2.585 3.07-2.585.466 0 1.007.09 1.4.196.195.06.406.09.526.09.136.36.272 1.202.272 1.833-.062.09-.302.135-.378.045-.195-.72-.602-1.698-2.045-1.698-1.476 0-1.792.977-1.792 1.668 0 .87.723 1.502 1.28 1.848l1.203.752c.95.585 1.882 1.456 1.882 2.884m8.47 1.092l-.66-2.04c-.107-.33-.167-.375-.618-.375h-2.273c-.375 0-.465.044-.57.36l-.528 1.574c-.225.674-.33 1.08-.33 1.245 0 .178.074.268.435.298l.498.046c.105.076.105.32-.03.38-.392-.03-.858-.028-1.566-.043-.496 0-1.037.03-1.443.045-.092-.06-.122-.305-.03-.38l.496-.047c.36-.03.69-.194.902-.735.27-.69.693-1.664 1.324-3.344l1.535-4.057c.21-.542.302-.827.256-1.068.36-.105.617-.374.783-.57.09 0 .195.03.226.135.195.66.435 1.352.66 2.013l2.062 6.036c.437 1.29.632 1.513 1.28 1.588l.406.046c.106.076.076.32 0 .38a34.347 34.347 0 0 0-1.82-.043c-.724 0-1.295.03-1.732.045-.12-.06-.135-.305-.03-.38l.437-.047c.315-.03.526-.12.526-.27 0-.165-.074-.434-.194-.794m-2.694-5.99l-.948 2.614c-.12.346-.106.36.316.36h1.85c.437 0 .467-.06.332-.465l-.812-2.45c-.12-.36-.257-.766-.347-.946-.074.075-.224.437-.39.886m10.875-.046l1.716 3.468c.346.706.677 1.396 1.038 2.057.437-.706.812-1.486 1.19-2.252l1.414-2.867c.677-1.366 1.114-2.192 1.144-2.882.51.045.827.045 1.127.045.376 0 .874-.015 1.34-.044.09.06.09.316.015.375l-.316.03c-.947.09-1.07.376-1.053 1.427.03 1.59.044 4.368.166 6.53.044.75.028 1.156.735 1.216l.482.046c.09.09.075.32-.03.38a36.388 36.388 0 0 0-3.597 0c-.106-.076-.12-.29-.03-.38l.437-.046c.737-.075.737-.316.737-1.276l-.044-6.26c-.137.166-.71 1.37-1.01 1.954l-1.34 2.63c-.676 1.322-1.353 2.734-1.624 3.424-.03.046-.09.06-.15.06-.03 0-.106-.014-.136-.06-.256-.795-.977-2.268-1.324-3.004l-1.354-2.9c-.316-.69-.633-1.472-.964-2.163-.09.93-.135 1.803-.18 2.67-.045.917-.105 2.253-.105 3.528 0 1.113.09 1.353.677 1.398l.572.046c.105.09.09.335-.015.38a28.8 28.8 0 0 0-3.205 0c-.09-.076-.12-.304-.03-.38l.33-.046c.632-.09.844-.18.933-1.23.09-.99.165-1.817.257-3.303.075-1.247.134-2.522.164-3.348.03-.946-.09-1.17-1.008-1.292l-.24-.03c-.076-.09-.06-.315.06-.374.452.03.814.045 1.188.045.346 0 .753 0 1.25-.044-.06.586.316 1.517.782 2.477m15.006 0l1.716 3.468c.345.706.677 1.396 1.04 2.057.435-.706.81-1.486 1.186-2.252l1.416-2.867c.677-1.366 1.112-2.192 1.143-2.882.512.045.827.045 1.128.045.376 0 .872-.015 1.34-.044.09.06.09.316.014.375l-.315.03c-.948.09-1.068.376-1.053 1.427.028 1.59.043 4.368.164 6.53.045.75.03 1.156.737 1.216l.483.046c.09.09.075.32-.03.38a36.414 36.414 0 0 0-3.597 0c-.106-.076-.12-.29-.03-.38l.436-.046c.738-.075.738-.316.738-1.276l-.046-6.26c-.135.166-.707 1.37-1.007 1.954l-1.34 2.63c-.677 1.322-1.354 2.734-1.626 3.424-.027.046-.09.06-.15.06-.028 0-.104-.014-.135-.06-.255-.795-.978-2.268-1.323-3.004l-1.355-2.9c-.316-.69-.63-1.472-.963-2.163-.09.93-.135 1.803-.18 2.67a73.63 73.63 0 0 0-.106 3.528c0 1.113.092 1.353.677 1.398l.572.046c.105.09.092.335-.014.38a28.84 28.84 0 0 0-3.206 0c-.09-.076-.12-.304-.03-.38l.33-.046c.633-.09.844-.18.934-1.23.09-.99.166-1.817.258-3.303.075-1.247.134-2.522.164-3.348.03-.946-.09-1.17-1.007-1.292l-.242-.03c-.075-.09-.06-.315.06-.374.453.03.814.045 1.19.045.345 0 .752 0 1.248-.044-.058.586.317 1.517.784 2.477m12.828 5.23V55.76c0-1.58-.03-1.82-.978-1.895l-.377-.03c-.09-.06-.06-.33.03-.374.844.03 1.356.045 1.957.045.587 0 1.1-.015 1.85-.044.092.045.122.316.03.375l-.36.03c-.887.076-.918.316-.918 1.894v5.227c0 .946.045 1.337.317 1.622.165.164.452.345 1.64.345 1.28 0 1.595-.06 1.835-.196.302-.18.693-.722.993-1.488.092-.074.378-.015.378.09 0 .165-.422 1.698-.632 2.104-.767-.03-2.197-.045-3.748-.045h-1.384c-.632 0-1.113.015-1.956.046-.09-.045-.12-.286-.03-.382l.45-.046c.875-.09.904-.3.904-1.87m15.732-2.165v-1.727c0-.93-.03-2.66-.286-3.11-.105-.18-.376-.285-.752-.315l-.377-.03c-.09-.105-.06-.3.03-.36.57.03 1.13.045 1.715.045.633 0 1.038-.015 1.58-.044.12.075.105.27.03.36l-.36.03c-.376.03-.663.165-.754.36-.21.497-.21 2.224-.21 3.066v1.697c0 1.308-.21 2.69-1.052 3.59-.648.707-1.76 1.098-2.875 1.098-1.038 0-2.076-.194-2.814-.825-.798-.662-1.175-1.76-1.175-3.546v-3.546c0-1.563-.03-1.818-.902-1.893l-.377-.03c-.09-.06-.06-.315.03-.36.753.03 1.264.045 1.866.045.618 0 1.115-.015 1.85-.044.092.045.122.3.032.36l-.362.03c-.872.076-.902.33-.902 1.894v3.245c0 2.418.752 4.01 3.054 4.01 2.183 0 3.01-1.713 3.01-3.997m13.502-1.73v3.593c0 .45 0 2.24.044 2.63-.03.09-.12.165-.286.165-.18-.255-.616-.78-1.926-2.274l-3.49-3.962c-.407-.466-1.43-1.697-1.747-2.027-.09.18-.104.525-.104.976v3.272c0 .706.015 2.657.272 3.108.09.165.39.255.766.285l.467.046c.092.122.076.304-.03.38a37.168 37.168 0 0 0-1.76-.043c-.632 0-1.038.014-1.565.045-.106-.077-.12-.29-.03-.38l.408-.047c.344-.045.585-.135.66-.3.21-.54.197-2.372.197-3.093v-4.34c0-.42-.016-.734-.33-1.08-.213-.21-.574-.315-.935-.36l-.256-.03c-.09-.09-.09-.315.03-.374.633.045 1.43.045 1.7.045.24 0 .498-.015.692-.044.3.766 2.076 2.748 2.573 3.303l1.46 1.636c1.038 1.156 1.775 1.996 2.483 2.716.09-.075.09-.315.09-.63v-3.212c0-.707-.015-2.657-.3-3.108-.09-.135-.33-.225-.933-.3l-.256-.03c-.106-.09-.092-.33.028-.375.693.03 1.204.045 1.776.045.648 0 1.04-.015 1.55-.044.12.075.12.286.03.375l-.21.03c-.482.076-.782.196-.844.316-.255.542-.224 2.403-.224 3.094m-16.265-45.45c1.622 0 3.05.385 3.397.693.346.847.615 2.08.615 3.12-.153.27-.733.346-.925.115-.656-1.694-1.814-2.81-3.394-2.81-1.505 0-2.47.962-2.47 2.348 0 1.58 1.62 2.426 2.97 3.197 2.046 1.155 3.936 2.465 3.936 5.2 0 2.926-2.702 4.39-5.557 4.39-1.813 0-3.162-.385-4.127-1.155-.308-.732-.54-2.62-.463-3.89.193-.232.694-.27.887-.04.657 2.12 1.89 3.968 4.09 3.968 1.388 0 2.584-.81 2.584-2.465 0-1.772-1.543-2.734-2.97-3.543-2.24-1.27-3.82-2.62-3.82-4.738 0-2.81 2.314-4.39 5.247-4.39M3.613 21.76V7.896c0-4.044-.077-4.66-2.508-4.853L.14 2.965c-.23-.154-.155-.847.076-.963 2.16.078 3.474.116 5.016.116 1.504 0 2.816-.038 4.745-.116.232.116.308.81.077.963l-.926.077c-2.275.193-2.352.81-2.352 4.853v13.403c0 2.427.115 3.428.81 4.16.424.424 1.157.885 4.204.885 3.28 0 4.09-.153 4.707-.5.772-.462 1.774-1.848 2.547-3.813.23-.192.964-.038.964.232 0 .423-1.08 4.35-1.62 5.39-1.968-.076-5.633-.114-9.606-.114h-3.55c-1.62 0-2.855.038-5.016.115-.23-.115-.307-.73-.077-.98l1.157-.115c2.238-.232 2.315-.77 2.315-4.797m20.834 1.447v-6.74c0-1.503 0-1.695-1.04-2.39l-.35-.23c-.153-.153-.153-.577.04-.693.887-.308 3.086-1.31 3.973-1.887.192 0 .347.077.386.23a90.092 90.092 0 0 0-.155 4.777v6.933c0 2.773.08 3.158 1.468 3.35l.81.117c.27.196.193.86-.078.978a51.824 51.824 0 0 0-3.626-.112c-1.39 0-2.546.034-3.626.112-.27-.117-.348-.782-.078-.978l.81-.116c1.428-.193 1.466-.578 1.466-3.35M25.72 3.504c1.157 0 1.928.924 1.928 2.002 0 1.387-.964 2.003-2.044 2.003-1.196 0-1.968-.885-1.968-1.926 0-1.27.927-2.08 2.083-2.08M43.28 17.68h-7.136c-1.003 0-1.043.077-1.043 1.04 0 3.89 2.276 7.202 6.404 7.202 1.275 0 2.354-.385 3.55-1.887.386-.115.655.115.694.462-1.272 2.62-4.05 3.583-6.056 3.583-2.507 0-4.474-1.08-5.594-2.543-1.157-1.502-1.62-3.312-1.62-5.007 0-4.737 3.126-8.704 7.754-8.704 3.32 0 5.478 2.272 5.478 4.583 0 .54-.077.847-.154 1.002-.115.23-.656.268-2.276.268m-7.484-1.156h2.74c2.854 0 3.703-.153 4.01-.385.117-.076.234-.23.234-.73 0-1.08-.734-2.43-2.972-2.43-2.276 0-4.244 2.082-4.283 3.353 0 .077 0 .192.27.192m13.94 7.665V5.815c0-2.273-.04-2.503-1.195-3.196l-.386-.233c-.194-.115-.194-.654 0-.77C49.043 1.27 50.896.77 52.36 0c.154 0 .308.077.387.23a84.41 84.41 0 0 0-.156 4.776v7.28c0 .655.157.808.387.808 1.003-.577 2.547-1.27 4.438-1.27 4.397 0 7.367 3.312 7.367 7.548 0 5.123-3.703 8.706-8.873 8.706a11.04 11.04 0 0 1-3.28-.502c-.81-.27-1.312-.5-1.62-.5-.31 0-.617.307-.81.577-.04.04-.078.04-.154.04a.424.424 0 0 1-.386-.232c.038-.538.077-1.27.077-3.273m2.854-7.896v6.01c0 1.348.31 2.542.966 3.35.657.81 1.698 1.272 2.932 1.272 3.626 0 5.054-3.08 5.054-6.394 0-3.967-2.045-7.048-5.863-7.048-1.16 0-2.085.27-2.626.616-.386.27-.463.693-.463 2.195m16.914 6.917v-6.74c0-1.503 0-1.695-1.043-2.39l-.346-.23c-.155-.153-.155-.577.038-.693.888-.308 3.088-1.31 3.974-1.887.194 0 .347.077.385.23a90.135 90.135 0 0 0-.153 4.777v6.933c0 2.773.077 3.158 1.466 3.35l.81.117c.27.196.192.86-.076.978a51.884 51.884 0 0 0-3.627-.112c-1.39 0-2.547.034-3.627.112-.27-.117-.347-.782-.077-.978l.81-.116c1.428-.193 1.468-.578 1.468-3.35m1.27-19.703c1.158 0 1.93.924 1.93 2.002 0 1.387-.963 2.003-2.044 2.003-1.196 0-1.968-.885-1.968-1.926 0-1.27.926-2.08 2.083-2.08m17.4 14.174h-7.138c-1.004 0-1.042.077-1.042 1.04 0 3.89 2.276 7.202 6.404 7.202 1.273 0 2.352-.385 3.548-1.887.386-.115.656.115.694.462-1.273 2.62-4.05 3.583-6.056 3.583-2.507 0-4.476-1.08-5.594-2.543-1.157-1.502-1.62-3.312-1.62-5.007 0-4.737 3.124-8.704 7.753-8.704 3.318 0 5.48 2.272 5.48 4.583 0 .54-.078.847-.155 1.002-.116.23-.656.268-2.276.268m-7.484-1.156h2.74c2.854 0 3.702-.153 4.01-.385.116-.076.233-.23.233-.73 0-1.08-.734-2.43-2.97-2.43-2.278 0-4.245 2.082-4.284 3.353 0 .077 0 .192.27.192m26.053-3.31h3.124c.425.19.348 1.5-.23 1.577h-2.78c.078.654.078 1.31.078 1.964 0 2.657-1.582 6.123-6.48 6.123-.696 0-1.235-.077-1.697-.115-.464.27-1.7 1-1.7 2.118 0 .886.888 1.618 2.7 1.618 1.314 0 2.895-.115 4.593-.115 2.16 0 5.4.384 5.4 4.236 0 4.197-4.59 7.28-9.604 7.28-4.745 0-6.405-2.543-6.405-4.47 0-.616.155-1.117.425-1.424.656-.693 1.737-1.695 2.625-2.58.345-.348.654-.694.308-.926-1.504-.385-2.816-1.694-2.816-3.042 0-.193.154-.347.58-.655.655-.423 1.387-1.078 2.043-1.77.193-.233.386-.54.386-.733-1.31-.693-2.893-2.195-2.893-4.66 0-3.313 2.856-5.816 6.288-5.816 1.466 0 2.816.385 3.705.77 1.234.54 1.503.617 2.353.617m-3.627 15.56h-1.312c-1.233 0-2.778.077-3.317.424-.927.577-1.853 1.772-1.853 3.235 0 2.08 1.66 3.812 5.17 3.812 3.434 0 5.71-1.925 5.71-4.12 0-2.35-1.62-3.35-4.398-3.35m-2.083-7.01c2.083 0 3.163-1.657 3.163-4.007 0-2.62-1.08-4.814-3.434-4.814-1.85 0-3.24 1.695-3.24 4.314 0 2.735 1.66 4.507 3.51 4.507m13.362 1.45V5.816c0-2.273-.038-2.503-1.196-3.196l-.386-.233c-.192-.115-.192-.654 0-.77.964-.308 2.777-.885 4.166-1.617.154 0 .31.077.386.23-.038 1.156-.115 3.082-.115 4.776v8.088c0 .347.037.655.152.73 1.39-1.076 3.242-2 5.21-2 3.664 0 4.976 2.272 4.976 4.964v6.423c0 2.77.077 3.193 1.466 3.348l1.04.116c.272.196.194.86-.077.978a64.108 64.108 0 0 0-3.856-.112c-1.388 0-2.546.034-3.588.112-.27-.117-.347-.782-.077-.978l.772-.116c1.428-.232 1.467-.577 1.467-3.347v-5.5c0-2.46-1.197-4.114-3.666-4.114-1.312 0-2.315.46-3.01 1.038-.694.577-.81.77-.81 2.116v6.46c0 2.77.078 3.156 1.467 3.348l.81.116c.27.156.192.86-.078.978a51.816 51.816 0 0 0-3.625-.112c-1.39 0-2.548.034-3.782.112-.27-.117-.346-.782-.077-.978l.965-.116c1.428-.155 1.466-.577 1.466-3.347m22.284-1.99l4.593-1.655c.578-.193.656-.538.656-1.116l.038-1.773c.04-1.426-.424-3.35-2.816-3.35-1.08 0-2.392.538-2.47 1.732-.037.615-.076 1.077-.385 1.31-.578.46-1.62.73-2.2.73-.345 0-.54-.193-.54-.54 0-2.002 4.36-4.736 7.178-4.736 2.778 0 4.128 1.617 4.012 4.506l-.23 6.702c-.078 1.77.268 3.35 1.774 3.35.384 0 .732-.115.964-.23.193-.117.385-.27.502-.27.153 0 .27.23.27.5 0 .193-1.352 1.696-3.242 1.696-.926 0-1.85-.347-2.507-1.195-.154-.23-.386-.54-.617-.54-.27 0-.733.347-1.506.77-.847.463-1.695.965-2.776.965-1.12 0-2.046-.31-2.7-.887a3.6 3.6 0 0 1-1.197-2.695c0-1.502.733-2.388 3.2-3.274m-.23 2.813c0 .654.463 2.31 2.432 2.31.77 0 1.966-.577 2.35-.962.465-.46.465-1 .503-1.81l.077-2.272c0-.424-.154-.5-.386-.5-.23 0-.887.154-1.58.385-2.277.77-3.396 1.347-3.396 2.85m17.784-8.59v6.433c0 2.657.655 4.43 3.587 4.43 1.042 0 2.276-.424 3.124-1.156.5-.463.772-1.04.772-2.234V16.6c0-2.504-.27-2.58-1.427-3.044l-.504-.192c-.27-.153-.27-.693.04-.847 1.542-.04 3.665-.308 4.513-.693.193.038.308.115.346.27-.076.73-.115 1.925-.115 3.35v6.47c0 3.043.116 4.2 1.196 4.2.463 0 .964-.08 1.506-.194.23.193.27.963-.04 1.117-1.504.308-3.74.694-5.052 1.426a.535.535 0 0 1-.464-.27v-1.58c0-.346-.116-.538-.348-.538-1.157.73-3.047 2.003-5.323 2.003-3.395 0-4.667-1.695-4.667-4.815V16.83c0-2.426 0-2.772-1.16-3.274l-.462-.192c-.23-.192-.192-.73.078-.847 1.774-.04 3.28-.385 4.127-.693.234.038.35.115.388.27-.077.654-.116 1.462-.116 3.35\" fill=\"#FFF\" fill-rule=\"evenodd\"></path></svg></div><span>Liebieghaus Skulpturensammlung</span></a></h1>");
$templateCache.put("app/components/digit-footer/digit-copyrights.html","<div class=\"g-row g-drop-2 g-push-2\"><div class=\"g-col-12\"><ui-md md=\"\'COPYRIGHTS_LIST\' | translate\"></ui-md></div></div>");
$templateCache.put("app/components/digit-footer/digit-footer.html","<footer class=\"digit-footer digit-footer--{{vm.context}}\"><div ng-style=\"{\'min-height\' : vm.outerHeight + \'px\'}\"><div class=\"digit-footer__inner\" ng-class=\"{\'show\' : vm.showSidebar}\"><div class=\"digit-footer__toggle\" ng-if=\"vm.context === \'sidebar\'\" ng-click=\"vm.showSidebar = !vm.showSidebar\"><em>i</em></div><div class=\"digit-footer__inner-content\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-3 g-align-m-right text-right-m g-push-3\" ng-if=\"vm.context === \'bottom\'\"><a class=\"cta cta--filled\" href=\"#top\" du-smooth-scroll=\"top\"><span translate=\"{{\'TOTOP\'}}\"></span><ui-button type=\"arrow-plain-up\"></ui-button></a></div><div class=\"g-col-12 g-col-m-9\"><h2 translate=\"{{\'ABOUT_THE_EXHIBITION\' | translate}}\"></h2></div></div><div class=\"g-row\"><div class=\"digit-footer__teaserwrapper\"><div class=\"digit-footer__teaser digit-footer__teaser--sharing\" ng-if=\"vm.context === \'sidebar\'\"><h3 translate=\"{{\'SHARING\' | translate}}\"></h3><a target=\"_blank\" href=\"{{main.sharing.facebook}}\"><ui-button custom=\"facebook\"></ui-button>Facebook</a> <a ng-if=\"device !== \'desktop\'\" target=\"_blank\" href=\"{{main.sharing.whatsapp}}\"><ui-button custom=\"whatsapp\"></ui-button>WhatsApp</a> <a href=\"{{main.sharing.mail}}\"><ui-button custom=\"mail\"></ui-button>E-Mail</a> <a target=\"_blank\" href=\"{{main.sharing.twitter}}\"><ui-button custom=\"twitter\"></ui-button>Twitter</a> <a target=\"_blank\" href=\"{{main.sharing.pinterest}}\"><ui-button custom=\"pinterest\"></ui-button>Pinterest</a></div><div class=\"digit-footer__teaser\"><h3 translate=\"{{\'SHOP_HEADING\' | translate}}\"></h3><figure><ui-img alt=\"\" image=\"cropped_besuch_programm_begleithefte.jpg\"></ui-img><figcaption>{{\'SHOP_TEXT\' | translate}}</figcaption></figure><a target=\"_blank\" class=\"cta\" ng-attr-href=\"{{\'SHOP_LINK\' | translate}}\"><span translate=\"{{\'SHOP_BUTTON\'}}\"></span><ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\"><h3 translate=\"{{\'ABOUT_HEADING\' | translate}}\"></h3><figure><ui-img alt=\"\" image=\"lh_16_05_a_616x344_service.jpg\"></ui-img><figcaption>{{\'ABOUT_TEXT\' | translate}}</figcaption></figure><a target=\"_blank\" class=\"cta\" ng-attr-href=\"{{\'ABOUT_LINK\' | translate}}\"><span translate=\"{{\'ABOUT_BUTTON\'}}\"></span><ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\" ng-if=\"main.currentLanguage === \'de\'\"><h3 translate=\"{{\'NEWSLETTER_HEADING\' | translate}}\"></h3><figure><ui-img alt=\"\" image=\"newsletter.jpg\"></ui-img><figcaption>{{\'NEWSLETTER_TEXT\' | translate}}</figcaption></figure><a target=\"_blank\" class=\"cta\" ng-attr-href=\"{{\'NEWSLETTER_LINK\' | translate}}\"><span translate=\"{{\'NEWSLETTER_BUTTON\'}}\"></span><ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser\"><h3 translate=\"{{\'KNOWLEDGE_HEADING\' | translate}}\"></h3><figure><ui-img alt=\"\" image=\"lh_16_05_a_616x344_digitorial_athen.jpg\"></ui-img><figcaption>{{\'KNOWLEDGE_TEXT\' | translate}}</figcaption></figure><a target=\"_blank\" class=\"cta\" ng-attr-href=\"{{\'KNOWLEDGE_LINK\' | translate}}\"><span translate=\"{{\'KNOWLEDGE_BUTTON\'}}\"></span><ui-button type=\"arrow-plain-right\"></ui-button></a></div><div class=\"digit-footer__teaser nobutton\" ng-if=\"vm.context === \'bottom\'\" ng-class=\"{\'noborder\' : main.currentLanguage === \'de\'}\"><h3 translate=\"{{\'NETWORK_WITH\' | translate}}\"></h3><p translate=\"{{\'FIND_ALL_YOU_NEED\' | translate}}\"></p><div class=\"digit-footer__socials\"><ui-socialicon new-window=\"true\" type=\"facebook\" theme=\"bright\" href=\"{{\'FACEBOOK_PROFILE_URL\' | translate}}\"></ui-socialicon><ui-socialicon new-window=\"true\" type=\"twitter\" theme=\"bright\" href=\"{{\'TWITTER_PROFILE_URL\' | translate}}\"></ui-socialicon><ui-socialicon new-window=\"true\" type=\"youtube\" theme=\"bright\" href=\"{{\'YOUTUBE_PROFILE_URL\' | translate}}\"></ui-socialicon></div></div></div></div><div class=\"g-row\" ng-if=\"vm.context === \'bottom\'\"><div class=\"g-col-12\"><div class=\"digit-footer__partner\"><p translate=\"{{\'DIGITORIAL_IS_MADE_POSSIBLE_BY\'}}\"></p><img src=\"assets/images/aventisfoundation.svg\" alt=\"Aventis Foundation\"></div></div></div><div class=\"g-row\" ng-if=\"vm.context === \'bottom\'\"><div class=\"g-col-12 g-col-m-12\"><div class=\"digit-footer__terminal\"><div class=\"g-row\"><div class=\"g-col-12 g-col-m-6 g-align-m-right clearfix\"><ul class=\"digit-footer__metanav\"><li><a href=\"{{\'PRIVACY_URL\' | translate}}\" target=\"_blank\">{{\'PRIVACY_TITLE\' | translate}}</a></li><li><a href=\"{{\'LEGALS_URL\' | translate}}\" target=\"_blank\">{{\'LEGALS_TITLE\' | translate}}</a></li><li><a href=\"#copyrights\" du-smooth-scroll=\"\" ng-click=\"vm.showCopyrights = !vm.showCopyrights\">{{\'COPYRIGHTS_TITLE\' | translate}}</a></li></ul></div><div class=\"g-col-12 g-col-m-6 g-drop-s-2\"><p translate=\"{{\'COPYRIGHT\'}}\"></p></div></div></div></div></div></div></div></div><aside class=\"digit-footer__copyrights\" id=\"copyrights\" ng-show=\"vm.showCopyrights\"><ng-include src=\"\'app/components/digit-footer/digit-copyrights.html\'\"></ng-include></aside></footer>");
$templateCache.put("app/components/ui-audioplayer/ui-audioplayer.html","<div class=\"ui-audioplayer\"><div class=\"g-row\"><div class=\"g-col-12 g-offset-m-2 g-col-m-8\"><audio ng-attr-media-player=\"{{vm.audio ? \'player\' : undefined }}\"><source ng-src=\"{{vm.audio}}\" type=\"audio/mp3\"></audio><ui-button custom=\"{{vm.customPlayButton}}\" type=\"play\" ng-if=\"!vm.isPlaying\" ng-click=\"vm.play()\"></ui-button><ui-button custom=\"{{vm.customPauseButton}}\" type=\"pause\" ng-if=\"vm.isPlaying\" ng-click=\"vm.pause()\"></ui-button><h4 ng-bind-html=\"vm.audiotitle\"></h4><em class=\"ui-audioplayer__time\" ng-if=\"vm.progress > 0\">{{player.formatTime}}</em></div></div><div class=\"ui-audioplayer__progress__wrapper\"><div class=\"ui-audioplayer__progress\" ng-click=\"vm.jumpToTime($event)\"><span ng-style=\"{width : (vm.progress * 100) + \'%\'}\"></span></div></div></div>");
$templateCache.put("app/components/ui-button/ui-button.html","<div class=\"ui-button ui-button--{{button.type}}{{button.custom}} is-{{button.state}} mod-{{button.mod}}\"><a ng-if=\"button.ref\" ui-sref=\"{{button.ref}}\" ng-click=\"button.blurCond()\"></a><div ng-if=\"button.custom\" class=\"ui-button__inner\"><ng-include src=\"\'app/global_styles/svg/\' + button.custom + \'.svg\'\"></ng-include></div><div ng-if=\"!button.custom\"><div ng-if=\"button.type === \'plus\' || button.type === \'openclose\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M30.426 53.426c12.703 0 23-10.297 23-23 0-12.702-10.297-23-23-23-12.702 0-23 10.298-23 23 0 12.703 10.298 23 23 23zm0 7c-16.568 0-30-13.43-30-30 0-16.568 13.432-30 30-30 16.57 0 30 13.432 30 30 0 16.57-13.43 30-30 30z\"></path><path d=\"M43.616 34.39l-.163-7.546h-8.956v-9.228h-8.142v9.228H17.4l-.164 7.545h9.12v9.226h8.14V34.39z\"></path></g></svg></div><div ng-if=\"button.type === \'arrow-plain-right\' || button.type === \'arrow-plain-up\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"61\" viewbox=\"0 0 61 62\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#1A1918\" d=\"M27.48 60.257L60 31.44v-2.624L27.48 0l-1.86 2.165 25.686 25.882H0v4.166H51.3l-25.68 25.88 1.86 2.164\" fill-rule=\"evenodd\"></path></svg></div><div ng-if=\"button.type === \'down-trans\' || button.type === \'play\' || button.type === \'arrow-right\' || button.type === \'arrow-left\' || button.type === \'arrow-up\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M7 30c0 12.703 10.297 23 23 23s23-10.297 23-23S42.703 7 30 7 7 17.297 7 30zm-7 0C0 13.43 13.43 0 30 0s30 13.43 30 30-13.43 30-30 30S0 46.57 0 30z\"></path><path d=\"M18.245 25.573s12.072 15.277 12.15 15.18l12.178-15.18H18.245z\"></path></g></svg></div><div ng-if=\"button.type === \'pause\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23zm0 7C13.43 60 0 46.57 0 30S13.43 0 30 0s30 13.43 30 30-13.43 30-30 30z\"></path><path d=\"M32 20h8v20h-8zM20 20h8v20h-8z\"></path></g></svg></div><div ng-if=\"button.type === \'lang-en\'\" class=\"ui-button__inner\"><svg ng-if=\"!button.custom\" width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23zm0 7C13.43 60 0 46.57 0 30S13.43 0 30 0s30 13.43 30 30-13.43 30-30 30z\"></path><path d=\"M27.712 37v-3.672h-7.104v-2.016h5.616V27.64h-5.616v-1.968h7.104V22H16v15h11.712zm12.792-6.48L35.176 22h-5.088v15h4.392v-8.496l5.4 8.64h5.016V22h-4.392v8.52z\"></path></g></svg></div><div ng-if=\"button.type === \'lang-de\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M30.664 29.392c0-4.464-3-7.392-8.448-7.392H16v15h5.88c5.664 0 8.784-3 8.784-7.608zm-4.752.144c0 2.664-1.416 3.84-3.768 3.84h-1.416v-7.752h1.176c2.76 0 4.008 1.128 4.008 3.912zM44.512 37v-3.672h-7.104v-2.016h5.616V27.64h-5.616v-1.968h7.104V22H32.8v15h11.712z\"></path><path d=\"M30 53c12.703 0 23-10.297 23-23S42.703 7 30 7 7 17.297 7 30s10.297 23 23 23zm0 7C13.43 60 0 46.57 0 30S13.43 0 30 0s30 13.43 30 30-13.43 30-30 30z\"></path></g></svg></div><div ng-if=\"button.type === \'share\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M36.253 33.856a4.728 4.728 0 0 0-3.5 1.547l-7.54-3.626c.18-.502.282-1.04.282-1.603s-.103-1.1-.283-1.603l7.54-3.625a4.732 4.732 0 0 0 3.5 1.55 4.747 4.747 0 1 0-4.746-4.748c0 .25.025.496.063.737l-8.028 3.86a4.72 4.72 0 0 0-2.795-.916 4.746 4.746 0 0 0 0 9.493c1.046 0 2.01-.342 2.794-.916l8.028 3.86c-.037.24-.063.486-.063.737a4.747 4.747 0 1 0 4.748-4.744z\"></path></g></svg></div><div ng-if=\"button.type === \'facebook\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M36.048 16.006l-3.5-.006c-3.935 0-6.477 2.608-6.477 6.645v3.063h-3.52a.55.55 0 0 0-.55.55v4.44c0 .304.247.55.55.55h3.52v11.2c0 .306.247.552.55.552h4.595a.55.55 0 0 0 .55-.55v-11.2h4.116a.55.55 0 0 0 .552-.552l.002-4.44a.55.55 0 0 0-.55-.55h-4.12V23.11c0-1.247.3-1.88 1.925-1.88l2.357-.002a.55.55 0 0 0 .55-.55v-4.122a.55.55 0 0 0-.55-.55z\"></path></g></svg></div><div ng-if=\"button.type === \'twitter\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M43 21.595c-.994.44-2.06.74-3.18.872a5.562 5.562 0 0 0 2.434-3.062 11.166 11.166 0 0 1-3.52 1.345 5.54 5.54 0 0 0-9.438 5.05 15.725 15.725 0 0 1-11.415-5.788 5.497 5.497 0 0 0-.748 2.784c0 1.922.98 3.617 2.463 4.61a5.54 5.54 0 0 1-2.508-.696v.07a5.544 5.544 0 0 0 4.442 5.43 5.61 5.61 0 0 1-1.46.195c-.358 0-.704-.036-1.043-.103A5.542 5.542 0 0 0 24.2 36.15a11.113 11.113 0 0 1-6.88 2.366c-.446 0-.886-.027-1.32-.076a15.656 15.656 0 0 0 8.49 2.492c10.19 0 15.758-8.44 15.758-15.76l-.018-.716a11.06 11.06 0 0 0 2.77-2.86z\"></path></g></svg></div><div ng-if=\"button.type === \'pinterest\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M37.47 18.767C35.61 16.983 33.037 16 30.226 16c-4.295 0-6.937 1.76-8.396 3.237-1.798 1.82-2.83 4.237-2.83 6.63 0 3.006 1.257 5.313 3.362 6.17.142.06.284.088.423.088.444 0 .796-.29.918-.756.07-.27.236-.928.308-1.215.154-.566.03-.838-.304-1.23-.61-.722-.893-1.574-.893-2.683 0-3.293 2.453-6.793 6.998-6.793 3.607 0 5.847 2.05 5.847 5.348 0 2.082-.448 4.01-1.263 5.43-.566.986-1.56 2.162-3.09 2.162-.66 0-1.254-.272-1.628-.745-.354-.447-.47-1.025-.328-1.628.16-.68.38-1.39.592-2.076.387-1.252.752-2.436.752-3.38 0-1.616-.993-2.7-2.47-2.7-1.88 0-3.35 1.906-3.35 4.342 0 1.194.317 2.087.46 2.43-.236 1.003-1.642 6.963-1.91 8.087-.153.655-1.082 5.837.456 6.25 1.728.464 3.272-4.583 3.43-5.153.127-.464.572-2.218.846-3.296.834.805 2.177 1.348 3.483 1.348 2.464 0 4.68-1.11 6.24-3.12 1.51-1.954 2.344-4.675 2.344-7.663 0-2.336-1.002-4.64-2.75-6.318z\"></path><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path></g></svg></div><div ng-if=\"button.type === \'email\'\" class=\"ui-button__inner\"><svg width=\"60\" height=\"60\" viewbox=\"0 0 61 61\" xmlns=\"http://www.w3.org/2000/svg\"><g fill=\"#FFF\" fill-rule=\"evenodd\"><path d=\"M13.737 46.263c8.982 8.983 23.544 8.983 32.526 0 8.983-8.982 8.983-23.544 0-32.526-8.982-8.983-23.544-8.983-32.526 0-8.983 8.982-8.983 23.544 0 32.526zm-4.95 4.95c-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0 11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0z\"></path><path d=\"M29.53 32.027h.007a.96.96 0 0 0 .525-.155l.04-.026c.01-.006.02-.01.03-.017l.475-.395 11.367-9.38a.134.134 0 0 0-.107-.055H17.132c-.03 0-.06.01-.082.03l11.893 9.802c.15.124.363.195.588.195zM17 23.33v13.903l8.52-6.882L17 23.33zm16.49 7.068l8.51 6.84V23.374l-8.51 7.023zm-2.706 2.232a1.97 1.97 0 0 1-1.25.432 1.97 1.97 0 0 1-1.25-.43l-1.95-1.61L17 38.563v.024c0 .072.06.133.134.133h24.734c.07 0 .132-.062.132-.134v-.022l-9.326-7.494-1.89 1.56z\"></path></g></svg></div></div></div>");
$templateCache.put("app/components/ui-chapterheading/ui-chapterheading.html","<div class=\"ui-chapterheading__container\" ng-class=\"{\'unfixed\' : vm.unfixed}\"><hr class=\"ui-chapterheading__progressor\"><div class=\"ui-chapterheading\" ng-class=\"{\'active\' : vm.active}\"><div class=\"ui-chapterheading__inner\" ng-attr-style=\"-ms-transform: {{vm.styles.inner.transform}}; transform: {{vm.styles.inner.transform}}; opacity: {{vm.styles.inner.opacity}}\"><ng-transclude></ng-transclude></div><div class=\"ui-chapterheading__background\" ng-attr-style=\"-ms-transform: {{vm.styles.background.transform}}; transform: {{vm.styles.background.transform}}\"></div><div class=\"ui-chapterheading__image\" ng-attr-style=\"-ms-transform: {{vm.styles.image.transform}}; transform: {{vm.styles.image.transform}}\"><ui-img alt=\"\" image=\"{{vm.img}}\" cover=\"true\" crop=\"top\"></ui-img></div></div></div>");
$templateCache.put("app/components/ui-check-device/ui-check-device.html","<div class=\"ui-check-device\" ng-class=\"{\'missing-features\' : !vm.features, \'wrong-ratio\' : !vm.ratio}\"><div class=\"ui-check-device__inner\"><h1 class=\"msg msg--missing-features\"><svg width=\"100\" height=\"87\" viewbox=\"0 0 100 87\" xmlns=\"http://www.w3.org/2000/svg\"><title>legacy</title><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M86.098 59.007c-1.182 0-2.33.15-3.426.427l-8.164-21.976c-2.98-8.024-8.273-14.895-15.306-19.87a42.56 42.56 0 0 0-6.462-3.77l5.538-5.524a1.59 1.59 0 0 0 .346-1.734 1.596 1.596 0 0 0-1.474-.982H46.32c-.88 0-1.594.712-1.594 1.59 0 .88.714 1.592 1.595 1.592h6.977l-3.73 3.722A42.23 42.23 0 0 0 36.308 9.84V3.182h2.658c.88 0 1.596-.712 1.596-1.592 0-.878-.715-1.59-1.596-1.59h-8.51c-.882 0-1.596.712-1.596 1.59 0 .88.714 1.593 1.595 1.593h2.66v14.35C14.714 18.37 0 33.56 0 52.117c0 19.09 15.572 34.62 34.713 34.62 19.14 0 34.713-15.53 34.713-34.62 0-18.556-14.715-33.747-33.117-34.582v-4.51C52 13.67 66.02 23.77 71.515 38.565l8.175 22.01c-4.447 2.314-7.494 6.956-7.494 12.297 0 7.646 6.237 13.866 13.902 13.866 7.666 0 13.902-6.22 13.902-13.865 0-7.644-6.236-13.863-13.902-13.863zm-19.864-6.89c0 17.333-14.14 31.436-31.52 31.436C17.33 83.553 3.19 69.45 3.19 52.116c0-16.8 13.285-30.565 29.927-31.397v29.805H28.33c-.88 0-1.596.712-1.596 1.59 0 .88.715 1.592 1.596 1.592h12.766c.88 0 1.595-.712 1.595-1.59 0-.88-.713-1.592-1.594-1.592H36.31V20.72c16.64.83 29.924 14.595 29.924 31.396zm19.864 31.436c-5.905 0-10.71-4.792-10.71-10.682 0-3.972 2.188-7.442 5.423-9.282l3.672 9.88a1.596 1.596 0 1 0 2.992-1.105l-3.685-9.92a10.728 10.728 0 0 1 2.308-.253c5.906 0 10.71 4.79 10.71 10.68S92.005 83.554 86.1 83.554z\"></path><path d=\"M40.715 27.9C51.982 30.665 59.85 40.677 59.85 52.25c0 13.824-11.276 25.07-25.137 25.07-13.862 0-25.14-11.246-25.14-25.07 0-11.57 7.87-21.583 19.138-24.347a1.59 1.59 0 0 0-.76-3.09c-6.045 1.483-11.52 4.993-15.42 9.884-4.022 5.044-6.147 11.114-6.147 17.554 0 15.58 12.71 28.254 28.33 28.254 15.62 0 28.33-12.674 28.33-28.254 0-6.44-2.126-12.51-6.147-17.554-3.9-4.89-9.376-8.402-15.42-9.884a1.59 1.59 0 0 0-.762 3.09z\"></path></g></svg><br>Der Städel Onlinekurs erfordert einen modernen Browser und funktioniert ausschließlich auf einem Tablet oder Computer. Ihr Browser scheint leider nicht alle benötigten Features zu unterstützen. Bitte laden Sie sich einen <a href=\"http://outdatedbrowser.com/de\">modernen Browser</a> herunter um das Angebot zu nutzen.</h1><h1 class=\"msg msg--wrong-dimensions\"><svg width=\"68\" height=\"69\" viewbox=\"0 0 68 69\" xmlns=\"http://www.w3.org/2000/svg\"><title>resize</title><path d=\"M68 63.018v2.627a2.62 2.62 0 0 1-2.617 2.627h-2.616a2.62 2.62 0 0 1-2.617-2.627 2.62 2.62 0 0 1 2.617-2.627 2.62 2.62 0 0 1 2.616-2.627A2.62 2.62 0 0 1 68 63.02zm-2.617-34.24a2.62 2.62 0 0 0-2.616 2.623v5.463a2.616 2.616 0 0 0 5.233.003v-5.462a2.62 2.62 0 0 0-2.617-2.627zm0-15.807a2.623 2.623 0 0 0-2.616 2.628v5.462a2.62 2.62 0 0 0 2.616 2.627A2.623 2.623 0 0 0 68 21.057v-5.462a2.62 2.62 0 0 0-2.617-2.624zm0 31.613a2.62 2.62 0 0 0-2.616 2.627v5.46a2.62 2.62 0 0 0 2.616 2.628A2.62 2.62 0 0 0 68 52.67v-5.46a2.62 2.62 0 0 0-2.617-2.627zm0-44.583h-2.616a2.623 2.623 0 0 0-2.617 2.627 2.62 2.62 0 0 0 2.617 2.627 2.62 2.62 0 0 0 2.616 2.627A2.623 2.623 0 0 0 68 5.25V2.628A2.62 2.62 0 0 0 65.383 0zm-18.36 5.25h5.44a2.623 2.623 0 0 0 2.617-2.626A2.62 2.62 0 0 0 52.463 0h-5.44a2.623 2.623 0 0 0-2.616 2.627 2.62 2.62 0 0 0 2.616 2.624zm-31.49 0h5.44a2.623 2.623 0 0 0 2.618-2.626A2.62 2.62 0 0 0 20.978 0h-5.44a2.62 2.62 0 0 0-2.617 2.627c0 1.45 1.17 2.624 2.614 2.624zm15.747 0h5.44a2.62 2.62 0 0 0 2.614-2.626c0-1.45-1.17-2.624-2.614-2.624h-5.44a2.62 2.62 0 0 0-2.614 2.627c0 1.45 1.17 2.624 2.614 2.624zM2.617 7.88A2.623 2.623 0 0 0 5.233 5.25 2.623 2.623 0 0 0 7.85 2.625 2.623 2.623 0 0 0 5.23 0H2.618A2.623 2.623 0 0 0 0 2.627v2.627a2.622 2.622 0 0 0 2.617 2.624zm0 15.806a2.623 2.623 0 0 0 2.616-2.627v-5.462a2.623 2.623 0 0 0-2.616-2.627A2.623 2.623 0 0 0 0 15.595v5.462a2.623 2.623 0 0 0 2.617 2.627zm49.846 39.334h-5.44a2.62 2.62 0 0 0-2.616 2.627 2.62 2.62 0 0 0 2.616 2.627h5.44a2.62 2.62 0 0 0 2.617-2.627 2.62 2.62 0 0 0-2.617-2.627zm3.778-52.354l-16.183 2.03c-.715.086-.88.58-.375 1.088l5.543 5.565-17.34 17.412H5.23v-5.356a2.62 2.62 0 0 0-2.616-2.624A2.618 2.618 0 0 0 0 31.404v5.46c0 .468.152.883.364 1.26-.212.38-.364.795-.364 1.262V65.645a2.623 2.623 0 0 0 2.617 2.627h26.155c.465 0 .88-.153 1.257-.366.37.21.788.363 1.25.363h5.44a2.62 2.62 0 0 0 2.614-2.628 2.62 2.62 0 0 0-2.614-2.627h-5.337V40.28l17.343-17.415 5.538 5.56c.51.51.998.34 1.088-.377l2.02-16.248c.096-.71-.418-1.226-1.13-1.136z\" fill=\"#000\" fill-rule=\"evenodd\"></path></svg><br>Dieser Kurs ist aus Gründen der Nutzerfreundlichkeit und zur verbesserten Darstellung der Kursinhalte ausschließlich für Computer und Tablets ausgelegt. Melden Sie sich daher bitte von einem Gerät mit größerem Bildschirm an.</h1><h1 class=\"msg msg--wrong-orientation\"><svg width=\"143\" height=\"88\" viewbox=\"0 0 143 88\" xmlns=\"http://www.w3.org/2000/svg\"><title>orientation</title><g fill=\"#000\" fill-rule=\"evenodd\"><path d=\"M76 70.19H60.077c0 1.23.263 2.515.79 3.86a36.66 36.66 0 0 0 1.58 3.533c.528 1.012.792 1.734.792 2.165 0 .863-.314 1.61-.94 2.24-.626.63-1.367.947-2.224.947H34.78c-.855 0-1.596-.316-2.222-.947-.626-.63-.938-1.378-.938-2.24 0-.465.263-1.194.79-2.19a35.35 35.35 0 0 0 1.58-3.485c.528-1.326.79-2.622.79-3.883H7.906c-2.174 0-4.034-.78-5.583-2.34C.774 66.29 0 64.418 0 62.226V8.06c0-2.19.774-4.065 2.322-5.625C3.872.875 5.732.095 7.905.095h79.047c2.174 0 4.034.78 5.582 2.34 1.55 1.56 2.323 3.435 2.323 5.625V38h-6.324V8.06c0-.43-.156-.804-.47-1.12a1.512 1.512 0 0 0-1.11-.472H7.905c-.428 0-.8.158-1.112.472-.313.316-.47.69-.47 1.12v41.42c0 .432.158.804.47 1.12.313.315.684.473 1.112.473H76V70.19zM141.13 24.78a1.32 1.32 0 0 0-.966-.41c-.37 0-.692.137-.964.41l-2.786 2.764a16.6 16.6 0 0 0-5.25-3.355c-1.973-.794-4.003-1.19-6.09-1.19-3.928 0-7.358 1.19-10.287 3.57-2.93 2.378-4.858 5.482-5.787 9.31v.15a.66.66 0 0 0 .204.483.66.66 0 0 0 .482.204h4.265c.315 0 .53-.164.644-.493.6-1.43.98-2.265 1.136-2.508 1-1.628 2.33-2.907 3.987-3.836a10.786 10.786 0 0 1 5.358-1.393c2.872 0 5.366.978 7.48 2.936l-2.958 2.958a1.32 1.32 0 0 0-.407.965c0 .372.136.693.407.965.272.27.594.407.965.407h9.602c.372 0 .693-.136.965-.407.27-.272.406-.593.406-.965v-9.602c0-.37-.135-.693-.407-.964z\"></path><path d=\"M142.99 83.523v-38.18A4.34 4.34 0 0 0 138.64 41H83.344A4.343 4.343 0 0 0 79 45.344v38.18c0 2.398 1.948 4.344 4.344 4.344h55.298a4.342 4.342 0 0 0 4.347-4.345zM80.627 64.435a2.58 2.58 0 0 1 5.162 0 2.584 2.584 0 0 1-2.583 2.584 2.582 2.582 0 0 1-2.58-2.585zm7.422 19.037V45.4h49.717V83.47H88.05z\"></path></g></svg><br>Der Städel Onlinekurs ist für Breitbild optimiert. Bitte nutzen Sie diese Webapp im Breitbild-Seitenverhältnis oder drehen Sie ggf. Ihr Tablet um 90°.</h1></div></div>");
$templateCache.put("app/components/ui-dropmore/ui-dropmore.html","<div class=\"ui-dropmore is-{{dm.state}} ui-dropmore--{{dm.direction}} ui-dropmore--{{dm.color}}\"><div class=\"ui-dropmore__buttoncont\" ui-scrollmove=\"{{dm.aniDir}}\" end-at-y=\"0.5\" buffer=\"250\" end-at-x=\"dm.buttonStartPos\" force-pos-x=\"dm.forcedEndPos\"><ui-button type=\"openclose\" state=\"{{dm.state}}\" ng-click=\"dm.toggle()\" custom=\"{{dm.customButton}}\"></ui-button></div><div class=\"ui-dropmore__container\" ng-style=\"dm.state === \'open\' && {\'height\' : dm.innerHeight + \'px\'}\"><div class=\"ui-dropmore__inner\"><ng-transclude></ng-transclude></div></div></div>");
$templateCache.put("app/components/ui-fadeimage/ui-fadeimage.html","<div class=\"ui-fadeimage\" ng-style=\"{height: fi.containerHeight + \'px\'}\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/ui-magnifier/ui-magnifier.html","<div class=\"ui-magnifier\"><div class=\"ui-magnifier__baseimg\"><ui-img image=\"{{mg.baseImage.src}}\" format=\"{{mg.baseImage.format}}\"></ui-img></div><div class=\"ui-magnifier__clip\" ng-style=\"mg.styles.circle\"><div class=\"ui-magnifier__img\" ng-repeat=\"i in mg.images\" ng-style=\"mg.styles.imgs[$index]\"><ui-img image=\"{{i.src}}\" format=\"{{i.format}}\" hqfactor=\"{{i.hqfactor}}\"></ui-img></div></div><div class=\"ui-magnifier__circle\" ng-style=\"mg.styles.circle\"></div></div>");
$templateCache.put("app/components/ui-metaimage/ui-metaimage.html","<div class=\"ui-metaimage\"><h4 ng-if=\"vm.headline\" class=\"ui-metaimg__headline\">{{vm.headline}}</h4><figure class=\"ui-metaimg__image\"><ui-img ng-if=\"!vm.cropped\" image=\"{{vm.image}}\" tile=\"vm.tile\" fixed-height=\"vm.forceHeight\"></ui-img><div ng-if=\"vm.cropped\" class=\"ui-img\" ui-img-bg=\"\" image=\"vm.image\"></div><ui-button class=\"ui-metaimg__button\" type=\"openclose\" custom=\"{{vm.customButton}}\" state=\"{{vm.state}}\" ng-click=\"vm.toggle()\"></ui-button></figure><div class=\"ui-metaimg__body\" ng-style=\"{height : vm.bodyHeight + \'px\'}\"><div class=\"ui-metaimg__body-inner\" ng-style=\"{height: vm.innerHeight + \'px\'}\"><ng-transclude></ng-transclude></div></div></div>");
$templateCache.put("app/components/ui-parallax/ui-parallax.html","<div class=\"ui-parallax\" ng-attr-style=\"-ms-transform: {{vm.styles.transform}}; transform: {{vm.styles.transform}}\" ng-class=\"{\'active\' : vm.active}\"><ng-transclude></ng-transclude></div>");
$templateCache.put("app/components/ui-scrollfix/ui-scrollfix.html","<div class=\"ui-scrollfix\" ng-style=\"sf.stylesOuter\"><ng-transclude class=\"ui-scrollfix__content original\" ng-style=\"sf.stylesOriginal\"></ng-transclude><ng-transclude class=\"ui-scrollfix__content clone\" ng-style=\"sf.stylesClone\"></ng-transclude></div>");
$templateCache.put("app/components/ui-scrollfix-nonclone/ui-scrollfix-nonclone.html","<div class=\"ui-scrollfix-nonclone\" ng-style=\"sf.stylesOuter\"><ng-transclude class=\"ui-scrollfix-nonclone__content\" ng-style=\"sf.stylesInner\"></ng-transclude></div>");
$templateCache.put("app/components/ui-socialicon/ui-socialicon.html","<a href=\"{{icon.href}}\" ng-attr-target=\"{{icon.newWindow ? \'_blank\' : \'\'}}\" class=\"ui-socialicon ui-socialicon--{{icon.type}} ui-socialicon--{{icon.theme}}\" ng-click=\"icon.blurCond()\"><svg ng-if=\"icon.type === \'facebook\'\" xmlns=\"http://www.w3.org/2000/svg\" width=\"96.124\" height=\"96.123\" viewbox=\"0 0 96.124 96.123\"><path d=\"M72.09.02L59.623 0C45.62 0 36.57 9.285 36.57 23.656v10.907H24.037a1.96 1.96 0 0 0-1.96 1.96v15.804a1.96 1.96 0 0 0 1.96 1.96H36.57v39.876a1.96 1.96 0 0 0 1.96 1.96h16.352a1.96 1.96 0 0 0 1.96-1.96V54.287h14.654a1.96 1.96 0 0 0 1.96-1.96l.006-15.803a1.963 1.963 0 0 0-1.96-1.96H56.84v-9.247c0-4.444 1.06-6.7 6.848-6.7l8.397-.003a1.96 1.96 0 0 0 1.96-1.96V1.98A1.96 1.96 0 0 0 72.088.02z\"></path></svg><svg ng-if=\"icon.type === \'twitter\'\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 612 612\"><path d=\"M612 116.258a250.714 250.714 0 0 1-72.088 19.772c25.93-15.527 45.777-40.155 55.184-69.41-24.322 14.378-51.17 24.82-79.775 30.48-22.906-24.438-55.49-39.66-91.63-39.66-69.333 0-125.55 56.218-125.55 125.514 0 9.828 1.11 19.427 3.25 28.606-104.325-5.24-196.834-55.223-258.75-131.174-10.822 18.51-16.98 40.078-16.98 63.1 0 43.56 22.182 81.994 55.836 104.48A125.556 125.556 0 0 1 24.63 232.21v1.568c0 60.806 43.29 111.554 100.692 123.104-10.517 2.83-21.607 4.398-33.08 4.398-8.107 0-15.947-.803-23.634-2.333 15.985 49.907 62.336 86.2 117.253 87.194-42.946 33.655-97.098 53.656-155.915 53.656-10.134 0-20.116-.612-29.944-1.72 55.568 35.68 121.537 56.484 192.44 56.484 230.947 0 357.187-191.29 357.187-357.188l-.42-16.253C573.87 163.525 595.21 141.42 612 116.257z\" fill=\"#010002\"></path></svg><svg ng-if=\"icon.type === \'gplus\'\" xmlns=\"http://www.w3.org/2000/svg\" width=\"96.828\" height=\"96.827\" viewbox=\"0 0 96.828 96.827\"><path d=\"M62.617 0H39.525C29.235 0 22.112 2.256 15.7 7.552c-5.04 4.35-8.05 10.672-8.05 16.912 0 9.614 7.33 19.83 20.913 19.83 1.306 0 2.752-.133 4.028-.252l-.187.457c-.546 1.307-1.063 2.54-1.063 4.467 0 3.75 1.81 6.063 3.558 8.298l.22.283-.39.027c-5.61.384-16.05 1.1-23.676 5.787-9.007 5.355-9.707 13.145-9.707 15.404 0 8.988 8.376 18.06 27.09 18.06 21.76 0 33.146-12.005 33.146-23.863.003-8.77-5.14-13.1-10.6-17.698l-4.604-3.582c-1.423-1.18-3.195-2.646-3.195-5.364 0-2.673 1.773-4.437 3.337-5.993l.163-.165c4.973-3.917 10.61-8.358 10.61-17.964 0-9.658-6.036-14.65-8.938-17.048h7.663a.488.488 0 0 0 .266-.077l6.602-4.15A.5.5 0 0 0 62.617 0zM34.614 91.535c-13.264 0-22.176-6.195-22.176-15.416 0-6.022 3.645-10.397 10.824-12.998 5.75-1.935 13.17-2.03 13.244-2.03 1.257 0 1.89 0 2.893.125C48.68 67.822 53.14 71.29 53.14 77.895c0 8.414-7.1 13.64-18.528 13.64zm-.125-50.78c-11.133 0-15.753-14.632-15.753-22.467 0-3.984.906-7.042 2.77-9.35 2.023-2.532 5.487-4.167 8.825-4.167 10.22 0 15.873 13.74 15.873 23.234 0 1.498 0 6.055-3.148 9.22-2.117 2.113-5.56 3.532-8.568 3.532zM94.982 45.223H82.814V33.098a.5.5 0 0 0-.5-.5H77.08a.5.5 0 0 0-.5.5v12.125H64.473a.5.5 0 0 0-.5.5v5.304a.5.5 0 0 0 .5.5H76.58V63.73a.5.5 0 0 0 .5.5h5.234a.5.5 0 0 0 .5-.5V51.525h12.168a.5.5 0 0 0 .5-.5v-5.302a.5.5 0 0 0-.5-.5z\"></path></svg><svg ng-if=\"icon.type === \'youtube\'\" width=\"143\" height=\"100\" viewbox=\"0 0 143 100\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.743 0C8.393 0 0 8.393 0 18.743v61.852c0 10.35 8.393 18.743 18.743 18.743h104.96c10.35 0 18.743-8.393 18.743-18.743V18.743C142.446 8.393 134.054 0 123.704 0H18.744zm41.222 74.858v-50.38l33.112 25.19-33.112 25.19z\" fill=\"#000\" fill-rule=\"evenodd\"></path></svg><svg ng-if=\"icon.type === \'instagram\'\" width=\"100\" height=\"100\" viewbox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.835 0h74.33C94.226 0 100 5.226 100 12.834v74.333C100 94.775 94.224 100 87.166 100h-74.33C5.773 100 0 94.776 0 87.168V12.834C0 5.226 5.774 0 12.835 0zm60.01 11.11a4.513 4.513 0 0 0-4.5 4.503V26.39a4.513 4.513 0 0 0 4.5 4.5H84.15a4.515 4.515 0 0 0 4.5-4.5V15.612a4.515 4.515 0 0 0-4.5-4.502H72.845zM88.7 42.29h-8.8c.832 2.72 1.283 5.6 1.283 8.58 0 16.632-13.918 30.115-31.085 30.115-17.165 0-31.082-13.483-31.082-30.116 0-2.983.45-5.862 1.284-8.58h-9.184v42.242a3.987 3.987 0 0 0 3.975 3.976h69.637a3.987 3.987 0 0 0 3.976-3.976V42.29H88.7zM50.094 30.323c-11.09 0-20.083 8.712-20.083 19.46 0 10.748 8.993 19.46 20.084 19.46 11.093 0 20.086-8.712 20.086-19.46 0-10.748-8.992-19.46-20.086-19.46z\" fill=\"#000\" fill-rule=\"evenodd\"></path></svg><svg ng-if=\"icon.type === \'mail\'\" width=\"100\" height=\"75\" viewbox=\"0 0 100 75\" xmlns=\"http://www.w3.org/2000/svg\"><title>Shape</title><path d=\"M99.995 62.497c0 2.19-.615 4.225-1.6 6.01L66.817 33.183 98.05 5.86c1.22 1.93 1.95 4.2 1.95 6.64v49.997h-.005zm-49.997-22.9L93.455 1.576A12.35 12.35 0 0 0 87.495 0H12.5c-2.17 0-4.18.6-5.95 1.575l43.448 38.023zm12.114-2.3l-10.065 8.8a3.12 3.12 0 0 1-4.1 0l-10.074-8.8L5.905 73.072c1.915 1.2 4.16 1.926 6.59 1.926H87.49a12.35 12.35 0 0 0 6.59-1.925L62.112 37.3zM1.95 5.86A12.346 12.346 0 0 0 0 12.5v49.997c0 2.19.615 4.225 1.6 6.01l31.573-35.33L1.95 5.86z\" fill=\"#3A3A3A\" fill-rule=\"evenodd\"></path></svg></a>");
$templateCache.put("app/components/ui-zoomimage/ui-zoomimage.html","<div class=\"ui-zoomimage\" ng-style=\"{\'padding-top\' : (zi.ratio * 100) + \'%\'}\"><div class=\"ui-zoomimage__inner\"><div></div></div></div>");}]);